(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1373],{

/***/ 58462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowRight3 = function SvgArrowRight3(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 14,
        viewBox: "0 0 9 7"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        d: "M4.628.616a.5.5 0 1 0-.64.768L6.203 3.23H.5a.5.5 0 0 0 0 1h5.612L3.988 6a.5.5 0 1 0 .64.769l3.23-2.693a.5.5 0 0 0 0-.768z",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight3);


/***/ }),

/***/ 60696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$R": function() { return /* binding */ preventFocusOnMouseDown; },
/* harmony export */   "B3": function() { return /* binding */ setSVGTitle; },
/* harmony export */   "ef": function() { return /* binding */ getAccessibleButtonColor; },
/* harmony export */   "vR": function() { return /* binding */ generateOnKeyDownHandler; },
/* harmony export */   "yG": function() { return /* binding */ isKeyPressOnCustomControlClickEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);


var isKeyPressOnCustomControlClickEvent = function(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Enter" || (e === null || e === void 0 ? void 0 : e.key) === " " || (e === null || e === void 0 ? void 0 : e.key) === "Spacebar" || (e === null || e === void 0 ? void 0 : e.which) === 13 || (e === null || e === void 0 ? void 0 : e.which) === 32;
};
var generateOnKeyDownHandler = function(onClick) {
    for(var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        parameters[_key - 1] = arguments[_key];
    }
    return function(event) {
        if (isKeyPressOnCustomControlClickEvent(event)) {
            event.preventDefault();
            onClick.apply(void 0, [
                event
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(parameters)));
        }
    };
};
// the 'mousedown' event also emits 'focus' by default,
// so if we want to prevent focusing a keyboard-navigable element on click, we just need to catch that event.
var preventFocusOnMouseDown = function(event) {
    return event.preventDefault();
};
var setSVGTitle = function(containingSelector, title) {
    var specialCharactersRegex = /[^\w\s]/gi;
    var cleanSelector = containingSelector.replace(specialCharactersRegex, "");
    // bug fix:
    if (containingSelector.startsWith("#") && !cleanSelector.startsWith("#")) {
        cleanSelector = "#".concat(cleanSelector);
    }
    var element = document.querySelector("".concat(cleanSelector, " svg > title"));
    if (element === null || element === void 0 ? void 0 : element.textContent) {
        element.textContent = title;
    }
};
var ACCESSIBLE_COLOR_TRANISTIONS = {
    pink: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR
};
var getAccessibleButtonColor = function(color) {
    return ACCESSIBLE_COLOR_TRANISTIONS[color] || color;
};


/***/ }),

/***/ 16612:
/***/ (function(module) {

"use strict";

var URL_PREFIXES = {
    LP: "/lp/",
    FREE_TIER: "/ft/",
    SEO: "/s/",
    TEMPLATES: "/templates/",
    GO_TEMPLATES: "/go-templates/",
    TERMS: "/terms/",
    SECURITY: "/security/",
    PARTNERS: "/partners/",
    CS: "/cs/",
    INTEGRATIONS: "/integrations/",
    PODCASTS: "/pod/",
    VISION: "/vision/",
    LANG: "/lang/",
    EMAILS: "/emails/",
    HR: "/hr/",
    TEST: "/test/",
    DEVELOPERS: "/developers/",
    REFLECT: "/reflect/"
};
module.exports = {
    URL_PREFIXES: URL_PREFIXES
};


/***/ }),

/***/ 87154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ SIDE; },
/* harmony export */   "_": function() { return /* binding */ BELOW; }
/* harmony export */ });
var BELOW = "below";
var SIDE = "side";


/***/ }),

/***/ 65832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AUTO": function() { return /* binding */ AUTO; },
/* harmony export */   "BEST": function() { return /* binding */ BEST; },
/* harmony export */   "ECO": function() { return /* binding */ ECO; },
/* harmony export */   "GOOD": function() { return /* binding */ GOOD; },
/* harmony export */   "LOW": function() { return /* binding */ LOW; }
/* harmony export */ });
var AUTO = "q_auto";
var BEST = "q_auto:best";
var GOOD = "q_auto:good";
var ECO = "q_auto:eco";
var LOW = "q_auto:low";


/***/ }),

/***/ 5792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dj": function() { return /* binding */ SET_CLUSTER_FROM_PAGE_CONFIG_REASON; },
/* harmony export */   "ZD": function() { return /* binding */ PAGE_CONFIG; },
/* harmony export */   "ar": function() { return /* binding */ HP_COOKIE; },
/* harmony export */   "cv": function() { return /* binding */ SET_CLUSTER_FROM_SIGNUP_BUTTON_REASON; },
/* harmony export */   "kh": function() { return /* binding */ PLATFORM_COOKIE; },
/* harmony export */   "sL": function() { return /* binding */ HP_SIGNUP_BUTTON; },
/* harmony export */   "xf": function() { return /* binding */ PARAM; }
/* harmony export */ });
var PARAM = "hp_param";
var PAGE_CONFIG = "hp_page_config";
var HP_COOKIE = "hp_cookie";
var PLATFORM_COOKIE = "platform_cookie";
var HP_SIGNUP_BUTTON = "hp_signup_button";
//reasons
var SET_CLUSTER_FROM_PAGE_CONFIG_REASON = "set_cluster_from_page_config";
var SET_CLUSTER_FROM_SIGNUP_BUTTON_REASON = "set_cluster_from_signup_button";


/***/ }),

/***/ 10945:
/***/ (function(module) {

"use strict";

var CLUSTER_TYPE = "cluster";
var USE_CASE_TYPE = "use-case";
module.exports = {
    CLUSTER_TYPE: CLUSTER_TYPE,
    USE_CASE_TYPE: USE_CASE_TYPE
};


/***/ }),

/***/ 34496:
/***/ (function(module) {

"use strict";
// Used for GTM

module.exports = {
    HUBSPOT_FORM_SUBMITTED: "hubspotFormSubmitted",
    IN_PAGE_AB_TEST_EVENT_NAME: "inPageAbTest",
    SHOW_COOKIEHUB_DIALOG_EVENT_NAME: "showCookiehubDialog",
    TRIGGER_COOKIEHUB_DIALOG_EVENT_NAME: "triggerCookiehubDialog",
    SIGNUP_CLICKED: "signupClicked",
    CLICK_MAIN_NAV: "click_main_nav",
    FAQ_ACCORDION: "faq_accordion",
    SIGNUP_WITH_GOOGLE_CLICKED: "signupWithGoogleClicked",
    TAG_SELECTED: "tagSelected",
    META_DATA: "meta_data"
};


/***/ }),

/***/ 50663:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLUSTERS: function() {
        return CLUSTERS;
    },
    UTM_ADGROUP: function() {
        return UTM_ADGROUP;
    },
    UTM_BANNER: function() {
        return UTM_BANNER;
    },
    UTM_CAMPAIGN: function() {
        return UTM_CAMPAIGN;
    },
    UTM_KEYWORD: function() {
        return UTM_KEYWORD;
    },
    UTM_MEDIUM: function() {
        return UTM_MEDIUM;
    },
    UTM_SOURCE: function() {
        return UTM_SOURCE;
    },
    SIGNUP_REFERRER: function() {
        return SIGNUP_REFERRER;
    },
    LANDING_PAGE: function() {
        return LANDING_PAGE;
    }
});
var CLUSTERS = "clusters";
var UTM_ADGROUP = "utm_adgroup";
var UTM_BANNER = "utm_banner";
var UTM_CAMPAIGN = "utm_campaign";
var UTM_KEYWORD = "utm_keyword";
var UTM_MEDIUM = "utm_medium";
var UTM_SOURCE = "utm_source";
var SIGNUP_REFERRER = "signup_referrer";
var LANDING_PAGE = "landing_page";
module.exports = {
    CLUSTERS: CLUSTERS,
    UTM_ADGROUP: UTM_ADGROUP,
    UTM_BANNER: UTM_BANNER,
    UTM_CAMPAIGN: UTM_CAMPAIGN,
    UTM_KEYWORD: UTM_KEYWORD,
    UTM_MEDIUM: UTM_MEDIUM,
    UTM_SOURCE: UTM_SOURCE,
    SIGNUP_REFERRER: SIGNUP_REFERRER,
    LANDING_PAGE: LANDING_PAGE
};


/***/ }),

/***/ 54224:
/***/ (function(module) {

"use strict";

var CLUSTER = "cluster";
var SUB_CLUSTER = "subcluster";
var PREVENT_FREE_TIER_PARAM = "prevent_free_tier";
var SUPPORTED_OVERRIDE_QUERY_PARAMS = [
    CLUSTER,
    SUB_CLUSTER
];
var FORCE_PRICING = "force_pricing";
var FORCE_CURRENCY = "force-currency";
var DYNAMIC_ASSET_PARAM = "dimg";
var ACTIVE_TAB_ID = "ati";
var FROM_PARAM = "from";
module.exports = {
    CLUSTER: CLUSTER,
    SUB_CLUSTER: SUB_CLUSTER,
    PREVENT_FREE_TIER_PARAM: PREVENT_FREE_TIER_PARAM,
    SUPPORTED_OVERRIDE_QUERY_PARAMS: SUPPORTED_OVERRIDE_QUERY_PARAMS,
    FORCE_PRICING: FORCE_PRICING,
    FORCE_CURRENCY: FORCE_CURRENCY,
    DYNAMIC_ASSET_PARAM: DYNAMIC_ASSET_PARAM,
    ACTIVE_TAB_ID: ACTIVE_TAB_ID,
    FROM_PARAM: FROM_PARAM
};


/***/ }),

/***/ 77869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L4": function() { return /* binding */ XS_L; },
/* harmony export */   "LG": function() { return /* binding */ LG; },
/* harmony export */   "MD": function() { return /* binding */ MD; },
/* harmony export */   "MS": function() { return /* binding */ MS; },
/* harmony export */   "Mp": function() { return /* binding */ XXS; },
/* harmony export */   "Re": function() { return /* binding */ LGR; },
/* harmony export */   "SM": function() { return /* binding */ SM; },
/* harmony export */   "T3": function() { return /* binding */ XXL; },
/* harmony export */   "XL": function() { return /* binding */ XL; },
/* harmony export */   "XS": function() { return /* binding */ XS; },
/* harmony export */   "g4": function() { return /* binding */ XS_M; },
/* harmony export */   "l$": function() { return /* binding */ XS_ML; }
/* harmony export */ });
var XXS = "xss";
var XS_M = "xs_m";
var XS_ML = "xs_ml";
var XS_L = "xs_l";
var XS = "xs";
var SM = "sm";
var MS = "ms";
var MD = "md";
var LG = "lg";
var LGR = "lgr";
var XL = "xl";
var XXL = "xxl";


/***/ }),

/***/ 698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Al": function() { return /* binding */ TABLET_QUERY_MIN_WIDTH; },
/* harmony export */   "Dp": function() { return /* binding */ MD_DESKTOP; },
/* harmony export */   "JF": function() { return /* binding */ MD_DESKTOP_WIDTH; },
/* harmony export */   "JI": function() { return /* binding */ SMALL_MOBILE_QUERY_INCLUDED_MAX_WIDTH; },
/* harmony export */   "K0": function() { return /* binding */ HEADER_DESKTOP_MENU_MIN_WIDTH; },
/* harmony export */   "KI": function() { return /* binding */ FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH; },
/* harmony export */   "LG": function() { return /* binding */ LG; },
/* harmony export */   "LM": function() { return /* binding */ FOLD_TEST_MAX_WIDTH; },
/* harmony export */   "Ld": function() { return /* binding */ MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH; },
/* harmony export */   "Lk": function() { return /* binding */ MOBILE_QUERY_MIN_WIDTH; },
/* harmony export */   "M$": function() { return /* binding */ X_LARGE_SCREEN_MIN_WIDTH; },
/* harmony export */   "MD": function() { return /* binding */ MD; },
/* harmony export */   "Mp": function() { return /* binding */ XXS; },
/* harmony export */   "O$": function() { return /* binding */ MAX_DESKTOP_CONTENT_WIDTH; },
/* harmony export */   "SM": function() { return /* binding */ SM; },
/* harmony export */   "TI": function() { return /* binding */ MOBILE_QUERY_MAX_WIDTH_M; },
/* harmony export */   "W8": function() { return /* binding */ MOBILE_SMALL_PHONE_MAX_WIDTH; },
/* harmony export */   "Wh": function() { return /* binding */ MACBOOK_PRO_MAX_WIDTH; },
/* harmony export */   "XS": function() { return /* binding */ XS; },
/* harmony export */   "cb": function() { return /* binding */ SMALL_MOBILE_QUERY_MAX_WIDTH; },
/* harmony export */   "dD": function() { return /* binding */ MIN_HEADER_DESKTOP_MENU; },
/* harmony export */   "fm": function() { return /* binding */ TABLET_QUERY_MAX_WIDTH_MEDIA_QUERY; },
/* harmony export */   "g4": function() { return /* binding */ XS_M; },
/* harmony export */   "lF": function() { return /* binding */ MOBILE_QUERY; },
/* harmony export */   "lu": function() { return /* binding */ HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH; },
/* harmony export */   "mD": function() { return /* binding */ ALTERNATE_MAC_BOOK_PRO_MAX_WIDTH_QUERY; },
/* harmony export */   "po": function() { return /* binding */ MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH; },
/* harmony export */   "sk": function() { return /* binding */ MAX_DESKTOP_GRID_WIDTH; },
/* harmony export */   "vA": function() { return /* binding */ LARGE_SCREEN_MIN_WIDTH; },
/* harmony export */   "vc": function() { return /* binding */ MID_HEADER_DESKTOP_MENU; },
/* harmony export */   "y": function() { return /* binding */ TABLET_QUERY_MAX_WIDTH; },
/* harmony export */   "zD": function() { return /* binding */ MOBILE_QUERY_MAX_WIDTH; }
/* harmony export */ });
/* unused harmony exports RETINA_RATIO_QUERY, SMALL_PHONE_BREAK, X_LG, HEADER_DESKTOP_MENU_NARROW_SCREEN, XXS_QUERY, XS_QUERY, SM_QUERY, MD_QUERY, LG_QUERY, XL_QUERY, MAC_BOOK_PRO, MOBILE_RETINA_QUERY, HEADER_DESKTOP_MENU_MID_WIDTH, TABLET_QUERY, TABLET_RETINA_QUERY */
// Retina display
var RETINA_RATIO_QUERY = "(min-device-pixel-ratio: 2)";
// Max widths
var XXS = 360;
var SMALL_PHONE_BREAK = 380; // allow 390px to be in the next level
var XS_M = 450;
var XS = 768;
var SM = 991;
var MD = 1199;
var MD_DESKTOP = 1440;
var LG = 1599;
var X_LG = 1880;
var MAX_DESKTOP_CONTENT_WIDTH = 1050;
var MAX_DESKTOP_GRID_WIDTH = 1300;
var MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH = 1440;
var FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH = 1920;
var MID_HEADER_DESKTOP_MENU = 1280;
var MIN_HEADER_DESKTOP_MENU = 1229;
var HEADER_DESKTOP_MENU_NARROW_SCREEN = 1300;
var XXS_QUERY = "(max-width: ".concat(XXS, "px)");
var XS_QUERY = "(min-width: ".concat(XXS + 1, "px) and (max-width: ").concat(XS, "px)");
var SM_QUERY = "(min-width: ".concat(XS + 1, "px) and (max-width: ").concat(SM, "px)");
var MD_QUERY = "(min-width: ".concat(SM + 1, "px) and (max-width: ").concat(MD, "px)");
var LG_QUERY = "(min-width: ".concat(MD + 1, "px) and (max-width: ").concat(LG, "px)");
var XL_QUERY = "(min-width: ".concat(LG + 1, "px)");
var MAC_BOOK_PRO = "(max-width: ".concat(MD, "px)");
var ALTERNATE_MAC_BOOK_PRO_MAX_WIDTH_QUERY = "1441px";
var MOBILE_QUERY_MAX_WIDTH = "".concat(XS, "px");
var MOBILE_SMALL_PHONE_MAX_WIDTH = "".concat(SMALL_PHONE_BREAK, "px");
var MD_DESKTOP_WIDTH = "".concat(MD_DESKTOP, "px");
var MOBILE_QUERY_MIN_WIDTH = "".concat(XS_M + 1, "px");
var MOBILE_QUERY_MAX_WIDTH_M = "".concat(XS_M, "px");
var MOBILE_QUERY = "(max-width: ".concat(MOBILE_QUERY_MAX_WIDTH, ")");
var MOBILE_RETINA_QUERY = MOBILE_QUERY + " and " + RETINA_RATIO_QUERY;
var SMALL_MOBILE_QUERY_MAX_WIDTH = "".concat(XXS, "px");
var SMALL_MOBILE_QUERY_INCLUDED_MAX_WIDTH = "".concat(XXS - 1, "px");
var TABLET_QUERY_MIN_WIDTH = "".concat(XS + 1, "px");
var TABLET_QUERY_MAX_WIDTH = "".concat(SM, "px");
var TABLET_QUERY_MAX_WIDTH_MEDIA_QUERY = "(max-width: ".concat(SM, "px)");
var MACBOOK_PRO_MAX_WIDTH = "".concat(MD, "px");
var FOLD_TEST_MAX_WIDTH = "1270px";
var MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH = "".concat(MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, "px");
var HEADER_DESKTOP_MENU_MIN_WIDTH = "".concat(MIN_HEADER_DESKTOP_MENU, "px");
var HEADER_DESKTOP_MENU_MID_WIDTH = "".concat(MID_HEADER_DESKTOP_MENU, "px");
var HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH = "".concat(HEADER_DESKTOP_MENU_NARROW_SCREEN, "px");
var LARGE_SCREEN_MIN_WIDTH = "".concat(LG, "px");
var X_LARGE_SCREEN_MIN_WIDTH = "".concat(X_LG, "px");
var TABLET_QUERY = MD_QUERY;
var TABLET_RETINA_QUERY = TABLET_QUERY + " and " + RETINA_RATIO_QUERY;


/***/ }),

/***/ 35257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A1": function() { return /* binding */ HIDDEN; },
/* harmony export */   "AE": function() { return /* binding */ MODAL_BACKGROUND; },
/* harmony export */   "KW": function() { return /* binding */ LAYER_ONE; },
/* harmony export */   "OL": function() { return /* binding */ ALWAYS_ON_TOP; },
/* harmony export */   "Pt": function() { return /* binding */ TOP_BAR_SHADOW; },
/* harmony export */   "Sj": function() { return /* binding */ LANGUAGE_PICKER_MENU; },
/* harmony export */   "U8": function() { return /* binding */ TEMPLATE_GENERATOR_ACTION_BUTTONS; },
/* harmony export */   "gR": function() { return /* binding */ SIDE_NAV; },
/* harmony export */   "jP": function() { return /* binding */ BASE_TEMPLATE_ROOT; },
/* harmony export */   "nA": function() { return /* binding */ TOP_LAYER; },
/* harmony export */   "sE": function() { return /* binding */ TOP_BAR; },
/* harmony export */   "wc": function() { return /* binding */ LAYER_TWO; },
/* harmony export */   "xE": function() { return /* binding */ ZERO; }
/* harmony export */ });
/* unused harmony exports CATEGORY, COOKIES_BANNER, CANVAS_PREVIEW, SSR_CANVAS, REACT_CANVAS */
//TODO - Maybe use layers instead
var MODAL_BACKGROUND = 999;
var SIDE_NAV = 666;
var TOP_BAR = 555;
var TOP_BAR_SHADOW = 557;
var CATEGORY = 999;
var TOP_LAYER = 9;
var ZERO = 0;
var HIDDEN = -1;
var LAYER_ONE = 100;
var LAYER_TWO = 200;
var ALWAYS_ON_TOP = 10000000;
var COOKIES_BANNER = 1031;
var LANGUAGE_PICKER_MENU = 1032;
var BASE_TEMPLATE_ROOT = 1;
var TEMPLATE_GENERATOR_ACTION_BUTTONS = 1;
// CANVAS
var CANVAS_PREVIEW = 1;
var SSR_CANVAS = 1;
var REACT_CANVAS = (/* unused pure expression or super */ null && (-1));


/***/ }),

/***/ 24492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ withAbTests; },
/* harmony export */   "s": function() { return /* binding */ AbTestsContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var AbTestsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var withAbTests = function withAbTests(WrappedComponent) {
    var AbTestsComponent = /*#__PURE__*/ function(PureComponent) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AbTestsComponent, PureComponent);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(AbTestsComponent);
        function AbTestsComponent(props) {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, AbTestsComponent);
            var _this;
            _this = _super.call(this, props);
            _this.getAbTestsFromValue = _this.getAbTestsFromValue.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this));
            _this.getAbTestExactEventNameFromValue = _this.getAbTestExactEventNameFromValue.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this));
            _this.crossOriginLocaleAbTest = _this.getCrossOriginLocaleAbTestFromValue.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this));
            return _this;
        }
        (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(AbTestsComponent, [
            {
                key: "getAbTestsFromValue",
                value: function getAbTestsFromValue(value) {
                    return value && value.abTestVariants || [];
                }
            },
            {
                key: "getAbTestExactEventNameFromValue",
                value: function getAbTestExactEventNameFromValue(value) {
                    return value && value.abTestExactEventName || null;
                }
            },
            {
                key: "getCrossOriginLocaleAbTestFromValue",
                value: function getCrossOriginLocaleAbTestFromValue(value) {
                    return (value === null || value === void 0 ? void 0 : value.crossOriginLocaleAbTest) || null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    var _this_props = this.props, forwardedRef = _this_props.forwardedRef, rest = _object_without_properties(_this_props, [
                        "forwardedRef"
                    ]);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AbTestsContext.Consumer, {
                        children: function(value) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, _object_spread_props(_object_spread({
                                ref: forwardedRef
                            }, rest), {
                                abTests: _this.getAbTestsFromValue(value),
                                abTestExactEventName: _this.getAbTestExactEventNameFromValue(value),
                                crossOriginLocaleAbTest: _this.getCrossOriginLocaleAbTestFromValue(value)
                            }));
                        }
                    });
                }
            }
        ]);
        return AbTestsComponent;
    }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AbTestsComponent, _object_spread_props(_object_spread({}, props), {
            forwardedRef: ref
        }));
    });
};


/***/ }),

/***/ 3156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ withGenericConfig; },
/* harmony export */   "Z": function() { return /* binding */ GenericConfigContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var GenericConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var withGenericConfig = function withGenericConfig(WrappedComponent) {
    var GenericConfigComponent = /*#__PURE__*/ function(PureComponent) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(GenericConfigComponent, PureComponent);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(GenericConfigComponent);
        function GenericConfigComponent(props) {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GenericConfigComponent);
            return _super.call(this, props);
        }
        (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(GenericConfigComponent, [
            {
                key: "render",
                value: function render() {
                    var _this_props = this.props, forwardedRef = _this_props.forwardedRef, rest = _object_without_properties(_this_props, [
                        "forwardedRef"
                    ]);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GenericConfigContext.Consumer, {
                        children: function(value) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, _object_spread({
                                ref: forwardedRef
                            }, value, rest));
                        }
                    });
                }
            }
        ]);
        return GenericConfigComponent;
    }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GenericConfigComponent, _object_spread_props(_object_spread({}, props), {
            forwardedRef: ref
        }));
    });
};


/***/ }),

/***/ 39944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ withSegmentsData; },
/* harmony export */   "k": function() { return /* binding */ SegmentContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var SegmentContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var withSegmentsData = function withSegmentsData(WrappedComponent) {
    var SegmentDataComponent = /*#__PURE__*/ function(PureComponent) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(SegmentDataComponent, PureComponent);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(SegmentDataComponent);
        function SegmentDataComponent() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, SegmentDataComponent);
            return _super.apply(this, arguments);
        }
        (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(SegmentDataComponent, [
            {
                key: "render",
                value: function render() {
                    var _this_props = this.props, forwardedRef = _this_props.forwardedRef, rest = _object_without_properties(_this_props, [
                        "forwardedRef"
                    ]);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SegmentContext.Consumer, {
                        children: function(value) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, _object_spread({
                                ref: forwardedRef
                            }, rest, value));
                        }
                    });
                }
            }
        ]);
        return SegmentDataComponent;
    }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SegmentDataComponent, _object_spread_props(_object_spread({}, props), {
            forwardedRef: ref
        }));
    });
};


/***/ }),

/***/ 61217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var mondaySecrets = __webpack_require__(39590);
var store = mondaySecrets.getStore("homepage", process.env.CREDS_ENV || "development");
var _initializedStore;
var initStore = function() {
    var _ref = _async_to_generator(function() {
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        store.init()
                    ];
                case 1:
                    _state.sent();
                    _initializedStore = store;
                    return [
                        2
                    ];
            }
        });
    });
    return function initStore() {
        return _ref.apply(this, arguments);
    };
}();
var initStoreIfNeeded = function() {
    var _ref = _async_to_generator(function() {
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!_initializedStore) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        initStore()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function initStoreIfNeeded() {
        return _ref.apply(this, arguments);
    };
}();
var getStore = function() {
    var _ref = _async_to_generator(function() {
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        initStoreIfNeeded()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        _initializedStore
                    ];
            }
        });
    });
    return function getStore() {
        return _ref.apply(this, arguments);
    };
}();
var get = function() {
    var _ref = _async_to_generator(function(secretName) {
        var secretsStore, secret;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getStore()
                    ];
                case 1:
                    secretsStore = _state.sent();
                    secret = secretsStore.get(secretName);
                    return [
                        2,
                        secret || {}
                    ];
            }
        });
    });
    return function get(secretName) {
        return _ref.apply(this, arguments);
    };
}();
var getSync = function(secretName) {
    if (!_initializedStore) {
        console.log("getSync was called without initializing the store. Secret name: ".concat(secretName));
        initStore();
    }
    var secret = store.getSync(secretName);
    return secret || {};
};
module.exports = {
    initStore: initStore,
    get: get,
    getSync: getSync
};


/***/ }),

/***/ 37759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ button_arrow; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./static/svg/arrow-right-3.svg
var arrow_right_3 = __webpack_require__(58462);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/button-arrow/button-arrow.scss.js


var StyledArrowButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "enaldha0"
})("padding-left:12px;padding-right:6px;transition:", button_consts/* ARROW_TRANSITION */.NY, ";&.hover{padding-left:18px;padding-right:0px;}svg{fill:currentColor;height:12px;width:14px;}&.sm.signup{svg{width:15px;height:13px;}}&.md.signup,.lg.signup{svg{height:12px;width:16px;}}&.lg{svg{width:13px;height:11px;}}&.md{padding-left:10px;padding-right:5px;&.hover{padding-left:15px;padding-right:0px;}svg{width:12px;height:10px;}}&.xs{padding-left:8px;padding-right:4px;&.hover{padding-left:12px;padding-right:0px;}svg{width:12px;height:10px;}}&.sm{padding-left:8px;padding-right:4px;&.hover{padding-left:12px;padding-right:0px;}svg{width:10px;height:9px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/button-arrow/button-arrow.js





var ButtonArrow = function(props) {
    var size = props.size, hover = props.hover, isSignup = props.isSignup;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrowButton, {
        className: classnames_default()("arrow-wrapper", size, {
            hover: hover,
            signup: isSignup
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_3/* default */.Z, {})
    });
};
ButtonArrow.defaultProps = {
    size: sizes.MD
};
/* harmony default export */ var button_arrow = (ButtonArrow);


/***/ }),

/***/ 75650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ SUBSCRIBE_BUTTON_TYPE; },
/* harmony export */   "F9": function() { return /* binding */ YOUTUBE_POPUP_LINK_TYPE; },
/* harmony export */   "Mw": function() { return /* binding */ UNDERLINE_TRANSITION; },
/* harmony export */   "NY": function() { return /* binding */ ARROW_TRANSITION; },
/* harmony export */   "Q_": function() { return /* binding */ TWO_LINK_BUTTONS_TYPE; },
/* harmony export */   "ae": function() { return /* binding */ SIGNUP_COMBO_BUTTONS_TYPE; },
/* harmony export */   "ge": function() { return /* binding */ SIGNUP_BUTTON_TYPE; },
/* harmony export */   "iF": function() { return /* binding */ SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE; },
/* harmony export */   "jE": function() { return /* binding */ SECONDARY_BUTTON_TYPE; },
/* harmony export */   "ys": function() { return /* binding */ REGULAR_BUTTON_TYPE; }
/* harmony export */ });
var REGULAR_BUTTON_TYPE = "Regular";
var SECONDARY_BUTTON_TYPE = "Secondary";
var SIGNUP_BUTTON_TYPE = "Signup";
var TWO_LINK_BUTTONS_TYPE = "ButtonsCombo";
var SIGNUP_COMBO_BUTTONS_TYPE = "SignupButtonsCombo";
var SUBSCRIBE_BUTTON_TYPE = "Subscribe";
var YOUTUBE_POPUP_LINK_TYPE = "YouTube Popup";
var SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE = "SignupAndYoutubeComboButtonsCombo";
var TRANSITION_DURATION = "0.3s";
var UNDERLINE_TRANSITION = "background-size ".concat(TRANSITION_DURATION);
var ARROW_TRANSITION = "padding ".concat(TRANSITION_DURATION, " ease-in-out");


/***/ }),

/***/ 44195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var differenceInSeconds = (__webpack_require__(47292).differenceInSeconds);
var ref = __webpack_require__(57581), getAsync = ref.getAsync, setAsync = ref.setAsync, delAsync = ref.delAsync;
var initLogger = (__webpack_require__(28879).initLogger);
var Sentry = __webpack_require__(48491);
var toCacheable = function(provider) {
    // Provider and cache properties
    var key = provider.key();
    var params = provider.params();
    var refreshInterval = provider.refreshInterval();
    var cacheExpirationTime = provider.cacheExpirationTime();
    // Cache keys
    var CACHE_PREFIX = "homepage::cache_service";
    var cacheKey = "".concat(CACHE_PREFIX, "::").concat(key);
    // Logger init
    var logger = initLogger();
    var metadata = {
        provider: key,
        params: params,
        cacheKey: cacheKey
    };
    var shouldFetch = function(value) {
        var lastUpdatedAt = value && value.lastUpdatedAt;
        return differenceInSeconds(new Date(), lastUpdatedAt) > refreshInterval;
    };
    var invalidate = function() {
        var _ref = _async_to_generator(function() {
            var error;
            return _tsGenerator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            delAsync(cacheKey)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        logger.error(_object_spread_props(_object_spread({}, metadata), {
                            error: error
                        }), "cacheService:::invalidate failed");
                        throw error;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function invalidate() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetch = function() {
        var _ref = _async_to_generator(function() {
            var data, cacheData;
            return _tsGenerator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            provider.getData()
                        ];
                    case 1:
                        data = _state.sent();
                        if (!provider.validate(data)) {
                            Sentry.captureMessage("Failed to validate new data in cache-service for ".concat(key, "}"));
                            throw new Error("Validation failed for new data");
                        }
                        cacheData = JSON.stringify({
                            data: data,
                            lastUpdatedAt: new Date()
                        });
                        return [
                            4,
                            setAsync(cacheKey, cacheData, "EX", cacheExpirationTime)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function fetch() {
            return _ref.apply(this, arguments);
        };
    }();
    var getData = function() {
        var _ref = _async_to_generator(function() {
            var cacheValue, response, value, forceFetch, error, error1;
            return _tsGenerator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4,
                            getAsync(cacheKey)
                        ];
                    case 1:
                        cacheValue = _state.sent();
                        response = null;
                        if (!cacheValue) return [
                            3,
                            6
                        ];
                        logger.info(metadata, "cacheService:::fetch cache hit");
                        forceFetch = false;
                        // Try to parse the value in cache, if it fails, try to regenerate in order to get a new copy
                        // Might happen with corrupted json received from getData
                        try {
                            value = JSON.parse(cacheValue);
                            response = value.data;
                        } catch (error2) {
                            logger.error(_object_spread_props(_object_spread({}, metadata), {
                                error: error2
                            }), "cacheService:::fetch forced regenerating because of invalid json");
                            forceFetch = true;
                        }
                        if (!(forceFetch || shouldFetch(value))) return [
                            3,
                            5
                        ];
                        logger.info(_object_spread_props(_object_spread({}, metadata), {
                            forceFetch: forceFetch
                        }), "cacheService:::fetch re-fetching");
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch()
                        ];
                    case 3:
                        response = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        logger.error(_object_spread_props(_object_spread({}, metadata), {
                            forceFetch: forceFetch,
                            error: error
                        }), "cacheService:::fetch failed while re-fetching");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        logger.info(metadata, "cacheService:::fetch cache miss");
                        return [
                            4,
                            fetch()
                        ];
                    case 7:
                        response = _state.sent();
                        _state.label = 8;
                    case 8:
                        return [
                            2,
                            response
                        ];
                    case 9:
                        error1 = _state.sent();
                        logger.error(error1, "cacheService:::getData failed");
                        throw error1;
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function getData() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        getData: getData,
        invalidate: invalidate
    };
};
module.exports = {
    toCacheable: toCacheable
};


/***/ }),

/***/ 73645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var getCachedData = function() {
    var _ref = _async_to_generator(function(providerInstance) {
        var cacheService, cachedProvider, data;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    cacheService = __webpack_require__(44195);
                    cachedProvider = cacheService.toCacheable(providerInstance);
                    return [
                        4,
                        cachedProvider.getData()
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getCachedData(providerInstance) {
        return _ref.apply(this, arguments);
    };
}();
var BaseDataProvider = /*#__PURE__*/ function() {
    "use strict";
    function BaseDataProvider(params) {
        _classCallCheck(this, BaseDataProvider);
        this._params = params;
    }
    _createClass(BaseDataProvider, [
        {
            // The unique identifier of the provider
            key: "key",
            value: function key() {
                throw new Error("You must supply provider's key");
            }
        },
        {
            // The method use to fetch the data
            key: "getData",
            value: function getData() {
                return _async_to_generator(function() {
                    return _tsGenerator(this, function(_state) {
                        throw new Error("You must supply provider's key");
                    });
                })();
            }
        },
        {
            // The parameters received for fetching the data
            key: "params",
            value: function params() {
                return this._params || {};
            }
        },
        {
            // The interval in which the data will be refreshed, in seconds
            key: "refreshInterval",
            value: function refreshInterval() {
                return 60; // a minute
            }
        },
        {
            // The duration the cache value will remain valid, in seconds
            key: "cacheExpirationTime",
            value: function cacheExpirationTime() {
                return 60 * 60 * 24 * 7; // 7 days
            }
        },
        {
            // The method to validate the data
            key: "validate",
            value: function validate(data) {
                return true;
            }
        }
    ]);
    return BaseDataProvider;
}();
module.exports = {
    BaseDataProvider: BaseDataProvider,
    getCachedData: getCachedData
};


/***/ }),

/***/ 14688:
/***/ (function(module) {

"use strict";

var getFileExtension = function(filename) {
    if (!filename) return null;
    if (filename.indexOf(".") < 0) return null;
    return filename.split(".").pop().toLowerCase();
};
var removeFileExtension = function(filename) {
    if (filename.indexOf(".") < 0) return filename;
    return filename.substring(0, filename.lastIndexOf("."));
};
var replaceFileExtension = function(fileName, newExtension) {
    var pos = fileName.lastIndexOf(".");
    var untilPos = pos < 0 ? fileName.length : pos;
    return fileName.substring(0, untilPos) + ".".concat(newExtension);
};
module.exports = {
    getFileExtension: getFileExtension,
    replaceFileExtension: replaceFileExtension,
    removeFileExtension: removeFileExtension
};


/***/ }),

/***/ 52673:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
var MockLogger = /*#__PURE__*/ function() {
    "use strict";
    function MockLogger() {
        _classCallCheck(this, MockLogger);
        this.logs = [];
    }
    _createClass(MockLogger, [
        {
            key: "info",
            value: function info(info1) {
                this.logs.push(info1);
            }
        },
        {
            key: "error",
            value: function error(error1) {
                this.logs.push(error1);
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.logs = [];
            }
        },
        {
            key: "getLogs",
            value: function getLogs() {
                return this.logs;
            }
        }
    ]);
    return MockLogger;
}();
var initLogger = function() {
    return new MockLogger();
};
module.exports = {
    initLogger: initLogger
};


/***/ }),

/***/ 28879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getLogger = (__webpack_require__(13688).getLogger);
var ref = __webpack_require__(52673), initTestLogger = ref.initLogger;
var initLogger = function() {
    if (false) {}
    return getLogger();
};
module.exports = {
    initLogger: initLogger
};


/***/ }),

/***/ 57581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
var _this = void 0;
var redis = __webpack_require__(90178);
var promisify = (__webpack_require__(79720).promisify);
var _client;
var clientMethods = [
    "get",
    "mget",
    "set",
    "setex",
    "lpush",
    "lrange",
    "ltrim",
    "lrem",
    "sadd",
    "smembers",
    "sismember",
    "hset",
    "hget",
    "hgetall",
    "del",
    "srem",
    "scan",
    "exists"
];
var getClient = function(param) {
    var _callerFunctionName = param.callerFunctionName, callerFunctionName = _callerFunctionName === void 0 ? "Unknown function" : _callerFunctionName, _callerFunctionParams = param.callerFunctionParams, callerFunctionParams = _callerFunctionParams === void 0 ? [] : _callerFunctionParams;
    if (!_client) {
        console.log("Warning: ".concat(callerFunctionName, " with params: ").concat(callerFunctionParams, " is called before Redis client is initialized. Initializing client."));
        init();
    }
    return _client;
};
var init = function() {
    var logInfo = (__webpack_require__(98989).logInfo);
    logInfo("Initializing Redis");
    if (_client) {
        logInfo("Init Redis was called, although it's already initialized.");
        return;
    }
    var getSync = (__webpack_require__(61217).getSync);
    var ref = getSync("redis"), _port = ref.port, port = _port === void 0 ? process.env.REDIS_OVERRIDE_PORT : _port, _hostname = ref.hostname, hostname = _hostname === void 0 ? process.env.REDIS_OVERRIDE_HOSTNAME : _hostname, _password = ref.password, password = _password === void 0 ? process.env.REDIS_OVERRIDE_PASSWORD || "" : _password;
    _client = redis.createClient(port, hostname, {
        no_ready_check: true
    });
    _client.auth(password, function(err) {
        if (err) throw err;
    });
    _client.on("connect", function() {
        console.log("Connected to Redis on port ".concat(port));
    });
    _client.on("error", function(err) {
        console.log("Error ".concat(err));
    });
    _client.promsifiedMethods = {};
    clientMethods.forEach(function(methodName) {
        _client.promsifiedMethods[methodName] = promisifyMethod(_client, methodName);
    });
    setSIGINTListener();
};
var promisifyMethod = function(client, methodName) {
    var promisifed = promisify(client[methodName]).bind(client);
    // put it on instance for sequlize cache
    client["".concat(methodName, "Async")] = promisifed;
    return promisifed;
};
var getPromisifiedMethod = function(methodName) {
    var client = getClient({
        callerFunctionName: "getPromisifiedMethod",
        callerFunctionParams: [
            methodName
        ]
    });
    if (!client.promsifiedMethods[methodName]) {
        console.log("Promisified method ".concat(methodName, " does not exist. Creating it."));
        client.promsifiedMethods[methodName] = promisifyMethod(client, methodName);
    }
    return client.promsifiedMethods[methodName];
};
var setSIGINTListener = function() {
    process.on("SIGINT", function() {
        console.log("SIGINT received - stopping Redis client");
        getClient({
            callerFunctionName: "setSIGINTListener"
        }).quit();
    });
};
module.exports = {
    init: init,
    getAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("get").apply(_this, _toConsumableArray(args));
    },
    mgetAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("mget").apply(_this, _toConsumableArray(args));
    },
    setAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("set").apply(_this, _toConsumableArray(args));
    },
    setexAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("setex").apply(_this, _toConsumableArray(args));
    },
    lpushAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("lpush").apply(_this, _toConsumableArray(args));
    },
    lrangeAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("lrange").apply(_this, _toConsumableArray(args));
    },
    ltrimAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("ltrim").apply(_this, _toConsumableArray(args));
    },
    lremAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("lrem").apply(_this, _toConsumableArray(args));
    },
    saddAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("sadd").apply(_this, _toConsumableArray(args));
    },
    smembersAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("smembers").apply(_this, _toConsumableArray(args));
    },
    sismemberAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("sismember").apply(_this, _toConsumableArray(args));
    },
    hsetAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("hset").apply(_this, _toConsumableArray(args));
    },
    hgetAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("hget").apply(_this, _toConsumableArray(args));
    },
    hgetallAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("hgetall").apply(_this, _toConsumableArray(args));
    },
    delAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("del").apply(_this, _toConsumableArray(args));
    },
    sremAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("srem").apply(_this, _toConsumableArray(args));
    },
    scanAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("scan").apply(_this, _toConsumableArray(args));
    },
    existsAsync: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return getPromisifiedMethod("exists").apply(_this, _toConsumableArray(args));
    }
};


/***/ }),

/***/ 90958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Is": function() { return /* binding */ getClustersConfig; },
/* harmony export */   "PH": function() { return /* binding */ setClusterForUser; },
/* harmony export */   "aC": function() { return /* binding */ updateUserClustersListWithMultipleClusters; },
/* harmony export */   "cd": function() { return /* binding */ parsePageLoadClusters; },
/* harmony export */   "jw": function() { return /* binding */ getProductByClustersIds; },
/* harmony export */   "lR": function() { return /* binding */ updateUserClustersListWithSingleCluster; },
/* harmony export */   "lc": function() { return /* binding */ setClusterIdIfNeeded; }
/* harmony export */ });
/* unused harmony exports getCurrentClusters, getClusterIdsFromLastTagsSelection */
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10092);
/* harmony import */ var _services_cookies_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67798);
/* harmony import */ var _services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65488);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65023);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13019);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_localstorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50663);
/* harmony import */ var _constants_localstorage__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_constants_localstorage__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_query_params__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54224);
/* harmony import */ var _constants_query_params__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_constants_query_params__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5792);
/* harmony import */ var _constants_clusters_types_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10945);
/* harmony import */ var _constants_clusters_types_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_constants_clusters_types_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _mondaydotcomorg_clusters_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38542);
/* harmony import */ var _server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73645);
/* harmony import */ var _server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var constants_products__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84074);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16961);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(constants_clusters__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var services_utils_service_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20618);
/* harmony import */ var services_utils_service_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(services_utils_service_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_11__);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
















var MAX_CLUSTERS = 10;
var DEFAULT_HOMEPAGE_SOURCE = "na_hp";
var OPERATIONS = {
    ADDED: "added",
    UPDATED: "updated",
    NOTHING: "nothing",
    ADDED_AND_REMOVED: "added_and_removed"
};
//* *********************************  LEGACY UTM CLUSTER AND SUBCLUSTER COOKIE SUPPORT  *************************************************************** */
// Keeping support for old utm_cluster_id and utm_sub_cluster_id_cookies - will become obsolete eventually - Platform and Bigrain will use only data points
var setFinalClusterIdAndTrackEventIfNeeded = function(clusterId, reason, options) {
    (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.CLUSTER_COOKIE, clusterId);
    (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__.setUtmClusterId)(clusterId);
    if (options.sendBigBrainEvent) {
        (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__.trackEvent)(_constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.SET_CLUSTER_ID_EVENT_NAME, {
            kind: clusterId,
            info1: reason,
            info2: window.location.href
        });
    }
};
var setFinalSubClusterIdAndTrackEventIfNeeded = function(subClusterId, reason, options) {
    if (subClusterId) {
        (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.SUB_CLUSTER_COOKIE, subClusterId);
    }
    if (!subClusterId && (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.SUB_CLUSTER_COOKIE)) {
        //	removing the cookie so we won't have sub cluster of another cluster
        (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .removeCookie */ .nJ)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.SUB_CLUSTER_COOKIE);
    }
    (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__.setUtmSubClusterId)(subClusterId);
    if (options.sendBigBrainEvent) {
        (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__.trackEvent)(_constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.SET_SUB_CLUSTER_ID_EVENT_NAME, {
            kind: subClusterId,
            info1: reason,
            info2: window.location.href
        });
    }
};
var setClusterIdIfNeeded = function(configClusterId, subClusterId) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var clusterReason = options.reason || _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .SET_CLUSTER_FROM_PAGE_CONFIG_REASON */ .Dj;
    if (configClusterId) {
        setFinalClusterIdAndTrackEventIfNeeded(configClusterId, clusterReason, options);
        setFinalSubClusterIdAndTrackEventIfNeeded(subClusterId, clusterReason, options); //	setting if having, or clearing if not
    }
};
//* ********************************* END OF LEGACY UTM CLUSTER AND SUBCLUSTER COOKIE SUPPORT  *************************************************************** */
// ---------------------------------------------- //
// -----  MULTIPLE CLUSTERS ON LOCAL STORAGE ---- //
// ---------------------------------------------- //
var shouldSetClusterToUser = function(source) {
    //  if the source is cookie, we won't log, as it was logged already
    return ![
        _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .HP_COOKIE */ .ar,
        _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PLATFORM_COOKIE */ .kh
    ].includes(source);
};
var setClusterForUser = function(clusterId, clusterType, clusterSource) {
    var clusterExtraData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    //  todo: should move the utm_cluster_id logic into here
    //   and have a "black box" which will set the "right" cluster cookie for the user,
    //   which will be used on the next page load as default value (see getClusterValueAndSource)
    if (clusterId && shouldSetClusterToUser(clusterSource)) {
        updateUserClustersListWithSingleCluster(clusterId, clusterType, clusterSource, {
            clusterExtraData: clusterExtraData
        });
    }
};
// TODO: ASK Etay - can we keep this functions as is with the subCluster param etc.. ? there is a lot of code depending on it.
var getClusterInfoForCurrentSession = function(overrideParams, cookies, pageConfig, options) {
    // for making things simpler for now, subclusters must have cluster with them (in param/page config/etc...)
    var clusterId, subClusterId, clusterIdSource, subClusterIdSource;
    var isPricingPage = options.pricingPage; // platform cookies is relevant only for pricing page, and pricing page doesn't use page config
    if (overrideParams[_constants_query_params__WEBPACK_IMPORTED_MODULE_4__.CLUSTER]) {
        clusterId = overrideParams[_constants_query_params__WEBPACK_IMPORTED_MODULE_4__.CLUSTER];
        subClusterId = overrideParams[_constants_query_params__WEBPACK_IMPORTED_MODULE_4__.SUB_CLUSTER];
        clusterIdSource = _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PARAM */ .xf;
        subClusterIdSource = subClusterId && _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PARAM */ .xf;
    } else if (isPricingPage && cookies[_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.PLATFORM_ACCOUNT_CLUSTER_COOKIE]) {
        clusterId = cookies[_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.PLATFORM_ACCOUNT_CLUSTER_COOKIE];
        subClusterId = cookies[_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.PLATFORM_ACCOUNT_SUB_CLUSTER_COOKIE];
        clusterIdSource = _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PLATFORM_COOKIE */ .kh;
        subClusterIdSource = subClusterId && _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PLATFORM_COOKIE */ .kh;
    } else if (!isPricingPage && pageConfig.clusterId) {
        clusterId = pageConfig.clusterId;
        subClusterId = pageConfig.subClusterId;
        clusterIdSource = _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PAGE_CONFIG */ .ZD;
        subClusterIdSource = subClusterId && _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PAGE_CONFIG */ .ZD;
    } else {
        clusterId = pageConfig.clusterId;
        subClusterId = pageConfig.subClusterId;
        clusterIdSource = undefined;
        subClusterIdSource = subClusterId && _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PAGE_CONFIG */ .ZD;
    }
    return {
        clusterId: clusterId,
        subClusterId: subClusterId,
        clusterIdSource: clusterIdSource,
        subClusterIdSource: subClusterIdSource
    };
};
var parsePageLoadClusters = function(overrideParams, cookies, pageConfig) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return getClusterInfoForCurrentSession(overrideParams, cookies, pageConfig, options);
};
var createCluster = function(param) {
    var clusterId = param.clusterId, clusterType = param.clusterType, attributionTime = param.attributionTime, _source = param.source, source = _source === void 0 ? DEFAULT_HOMEPAGE_SOURCE : _source, _extraData = param.extraData, extraData = _extraData === void 0 ? {} : _extraData;
    return _object_spread({
        cluster_id: clusterId,
        type: clusterType,
        source: source,
        attribution_time: attributionTime,
        last_seen: attributionTime
    }, extraData);
};
var getIndexOfClusterIfExists = function(clustersOfUser, newCluster) {
    var indexOfClusterIfExists = null;
    clustersOfUser.some(function(e, index) {
        if (e.cluster_id === newCluster.cluster_id && e.type === newCluster.type && e.source === newCluster.source) {
            indexOfClusterIfExists = index;
            return true;
        }
    });
    return indexOfClusterIfExists;
};
var addOrUpdateClustersIfNeeded = function(param) {
    var clustersOfUser = param.clustersOfUser, newCluster = param.newCluster, attributionTime = param.attributionTime;
    var indexOfClusterIfExists = getIndexOfClusterIfExists(clustersOfUser, newCluster);
    if (indexOfClusterIfExists !== null) {
        clustersOfUser[indexOfClusterIfExists].last_seen = attributionTime;
        return OPERATIONS.UPDATED;
    }
    clustersOfUser.push(newCluster);
    if (clustersOfUser.length > MAX_CLUSTERS) {
        // removeOldestEntry(clustersOfUser); // following up first
        return OPERATIONS.ADDED_AND_REMOVED;
    }
    return OPERATIONS.ADDED;
};
var getCurrentClusters = function() {
    try {
        return JSON.parse(localStorage.getItem(_constants_localstorage__WEBPACK_IMPORTED_MODULE_3__.CLUSTERS)) || [];
    } catch (e) {
        return [];
    }
};
var saveClusters = function(clustersOfUser) {
    localStorage.setItem(_constants_localstorage__WEBPACK_IMPORTED_MODULE_3__.CLUSTERS, JSON.stringify(clustersOfUser));
};
var updateCluster = function(param) {
    var clustersOfUser = param.clustersOfUser, clusterId = param.clusterId, clusterType = param.clusterType, attributionTime = param.attributionTime, source = param.source, _extraData = param.extraData, extraData = _extraData === void 0 ? {} : _extraData;
    if (!clusterId) return;
    var newCluster = createCluster({
        clusterId: clusterId,
        clusterType: clusterType,
        attributionTime: attributionTime,
        source: source,
        extraData: extraData
    });
    var operationStatus = addOrUpdateClustersIfNeeded({
        clustersOfUser: clustersOfUser,
        newCluster: newCluster,
        attributionTime: attributionTime
    });
    (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__.trackEvent)(_constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.SET_CLUSTER_EVENT, {
        kind: operationStatus,
        info1: clusterId,
        info2: clusterType,
        info3: location.href,
        placement: source,
        data: JSON.stringify(extraData)
    });
};
var updateUserClustersListWithMultipleClusters = function(clusters, source) {
    var clustersOfUser = getCurrentClusters();
    var attributionTime = new Date().getTime();
    clusters.forEach(function(cluster) {
        var clusterId = cluster.clusterId, clusterType = cluster.clusterType, extraData = cluster.extraData;
        updateCluster({
            clustersOfUser: clustersOfUser,
            clusterId: clusterId,
            clusterType: clusterType,
            attributionTime: attributionTime,
            source: source,
            extraData: extraData
        });
    });
    saveClusters(clustersOfUser);
};
var updateUserClustersListWithSingleCluster = function(clusterId, clusterType, source) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var clusterExtraData = options.clusterExtraData, setSignupCluster = options.setSignupCluster, useCaseId = options.useCaseId, restOptions = _object_without_properties(options, [
        "clusterExtraData",
        "setSignupCluster",
        "useCaseId"
    ]);
    var clusters = [
        {
            clusterId: clusterId,
            clusterType: clusterType,
            extraData: clusterExtraData
        }
    ];
    if (useCaseId) {
        clusters.push({
            clusterId: useCaseId,
            clusterType: _constants_clusters_types_js__WEBPACK_IMPORTED_MODULE_5__.USE_CASE_TYPE,
            extraData: _object_spread_props(_object_spread({}, clusterExtraData), {
                parent_cluster_id: clusterId
            })
        });
    }
    updateUserClustersListWithMultipleClusters(clusters, source);
    if (clusterType === _constants_clusters_types_js__WEBPACK_IMPORTED_MODULE_5__.CLUSTER_TYPE && setSignupCluster) {
        setClusterIdIfNeeded(clusterId, useCaseId, restOptions);
    }
};
var getClustersConfig = function() {
    var _ref = _async_to_generator(function(clusterId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            return [
                2,
                _mondaydotcomorg_clusters_service__WEBPACK_IMPORTED_MODULE_6__/* .HOMEPAGE_CLUSTERS_DATA */ .r[clusterId]
            ];
        });
    });
    return function getClustersConfig(clusterId) {
        return _ref.apply(this, arguments);
    };
}();
var getClusterIdsFromLastTagsSelection = function(clusters) {
    var clustersFromTags = clusters.filter(function(cluster) {
        return cluster.source === HP_TAGS_SELECTION;
    });
    var lastAttributedCluster = orderBy(clustersFromTags, [
        "last_seen"
    ], [
        "desc"
    ])[0];
    var lastAttributedClusters = clustersFromTags.filter(function(cluster) {
        return cluster.last_seen === lastAttributedCluster.last_seen;
    });
    return lastAttributedClusters.map(function(cluster) {
        return cluster.cluster_id;
    });
};
var getProductByClustersIds = function(clustersIds) {
    // no selection or 'More workflows' is selected ('More workflows' is not assigned with a cluster)
    if (clustersIds.length === 0) {
        return null;
    }
    // all clusters that do not exist in the map, map to work management
    var productsIds = (0,services_utils_service_js__WEBPACK_IMPORTED_MODULE_10__.newUniqueArray)(clustersIds.map(function(clusterId) {
        return constants_products__WEBPACK_IMPORTED_MODULE_8__/* .clusterIdToProductIdMap */ .xr[clusterId] || constants_products__WEBPACK_IMPORTED_MODULE_8__/* .WORK_MANAGEMENT_PRODUCT_ID */ .py;
    }));
    // selection maps to a single product
    if (productsIds.length === 1) {
        return productsIds[0];
    }
    // selection maps to multiple products - return 'Work management'
    return constants_products__WEBPACK_IMPORTED_MODULE_8__/* .WORK_MANAGEMENT_PRODUCT_ID */ .py;
};


/***/ }),

/***/ 40927:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
var _cloudinaryAssetQualities = __webpack_require__(65832);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var SHA256 = __webpack_require__(52153);
var CLOUDINARY_CLOUD_NAME = "dapulse";
var CLOUDINARY_BASE = "https://dapulse-res.cloudinary.com/";
var CLOUDINARY_UNSECURE_BASE = "http://dapulse-res.cloudinary.com/";
var CLOUDINARY_STATIC_FOLDER = "remote_mondaycom_static";
var CLOUDINARY_IMAGE_DIRECTORY = "image/";
var CLOUDINARY_VIDEO_DIRECTORY = "video/";
var CLOUDINARY_STATIC_FOLDER_NAME = "/static";
var GENERATOR_FEATURED_IMAGES_FOLDER = "Generator_featured images";
var CLOUDINARY_MEDIA_LIBRARY_USER_NAME = "eranh@monday.com";
var CLOUDINARY_MEDIA_LIBRARY_SCRIPT = "https://media-library.cloudinary.com/global/all.js";
var CLOUDINARY_BASE_VIDEO_URL = "".concat(CLOUDINARY_STATIC_FOLDER, "/video/video-library");
var CLOUDINARY_VIDEO_RESOURCE = "video";
var CLOUDINARY_IMAGE_UPLOADS_BASE_FOLDER = "".concat(CLOUDINARY_STATIC_FOLDER, "/uploads");
var CLOUDINARY_IMAGE_RESOURCE = "image";
var CLOUDINARY_IMAGE_PREFIX = "".concat(CLOUDINARY_BASE).concat(CLOUDINARY_IMAGE_DIRECTORY);
var CLOUDINARY_VIDEO_PREFIX = "".concat(CLOUDINARY_BASE).concat(CLOUDINARY_VIDEO_DIRECTORY);
var LOW_RES_IMAGE_QUALITY_LEVEL = 1;
var IMAGE_DEFAULT_BLUR = 300;
var CLOUDINARY_IMAGE_FILE_TYPE = "IMAGE";
var CLOUDINARY_VIDEO_FILE_TYPE = "VIDEO";
var CLOUDINARY_GIF_FILE_TYPE = "GIF";
var CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE = "VIDEO_THUMBNAIL";
var GIF_FILE_EXTENSION = "gif";
var JPG_FILE_EXTENSION = "jpg";
var GIF_TO_VIDEO_AUTO_TRANSFORMATION = "f_mp4,f_auto";
var VIDEO_THUMBNAIL_TRANSFORMATION = "so_0p";
var FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM = "d";
var addBasePathToUrl = (__webpack_require__(932).addBasePathToUrl);
var ref = __webpack_require__(14688), getFileExtension = ref.getFileExtension, replaceFileExtension = ref.replaceFileExtension;
var PRODUCTION_CLOUDINARY_STATIC_FOLDER = "remote_mondaycom_static";
var STAGING_CLOUDINARY_STATIC_FOLDER = "remote_mondaystagingcom_static";
// Holds auto upload mappings configured in cloudinary account for use to migrate images to cloudinary from s3 buckets
var AutoUploadMappings = {
    "https://monday.com/static": PRODUCTION_CLOUDINARY_STATIC_FOLDER,
    "https://monday.com/Generator_featured images": GENERATOR_FEATURED_IMAGES_FOLDER,
    "https://mondaystaging.com/Generator_featured images": GENERATOR_FEATURED_IMAGES_FOLDER,
    "https://mondaystaging.com/static": STAGING_CLOUDINARY_STATIC_FOLDER
};
var AutoUploadMappingsKeys = Object.keys(AutoUploadMappings);
var defaultTransformationParams = {
    crop: "fill",
    gravity: "faces"
};
// For creating the url
var PresetKeysConvertion = {
    width: "w_",
    height: "h_",
    crop: "c_",
    gravity: "g_",
    aspectRatio: "ar_",
    radius: "r_",
    quality: "q_",
    blur: "e_blur:",
    raw: "raw",
    defaultImage: "d_"
};
var PresetKeysConvertionKey = Object.keys(PresetKeysConvertion);
// These presets are pre made by cloudinary and does not require any additional calculation (on-the-fly calculations)
// If changed - make sure to update the upload presets (both production and staging) in cloudinary account
var PresetTransformations = {
    SMALL_CARD: _object_spread({
        width: 328,
        height: 225
    }, defaultTransformationParams),
    FEATURE_CARD: _object_spread({
        aspectRatio: "704:410",
        width: 704,
        height: 410
    }, defaultTransformationParams),
    SMALL: _object_spread({
        width: 128
    }, defaultTransformationParams),
    MEDUIM: _object_spread({
        width: 256
    }, defaultTransformationParams),
    LARGE: _object_spread({
        width: 512
    }, defaultTransformationParams),
    XLARGE: _object_spread({
        width: 1024
    }, defaultTransformationParams),
    XXLARGE: _object_spread({
        width: 2048
    }, defaultTransformationParams),
    SMALL_ROUND: _object_spread({
        radius: "max",
        width: 128,
        height: 128
    }, defaultTransformationParams),
    TEMPLATE_COVER: _object_spread({
        aspectRatio: "1766:768"
    }, defaultTransformationParams)
};
var extractPublicId = function(src) {
    if (!src) {
        return {
            publicId: src
        };
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // checking if src is mapped in cloudinary for auto upload
        for(var _iterator = AutoUploadMappingsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (src.startsWith(key)) {
                // this url is for auto upload
                var id = src.substring(key.length);
                var newUrl = "".concat(AutoUploadMappings[key]).concat(id);
                return {
                    publicId: newUrl
                };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        isFetch: true,
        publicId: src
    }; // other urls that are not auto uploaded
};
var getCloudinaryMethodPostfix = function(isFetch) {
    return isFetch ? "fetch/" : "upload/";
};
var generateCloudinaryRawUrl = function(src) {
    var fixedSrc = addBasePathToUrl(src);
    var ref = extractPublicId(fixedSrc), isFetch = ref.isFetch, publicId = ref.publicId;
    var postfix = getCloudinaryMethodPostfix(isFetch);
    return "".concat(CLOUDINARY_BASE, "raw/").concat(postfix).concat(publicId);
};
var getPrefix = function(fileType) {
    switch(fileType){
        case CLOUDINARY_IMAGE_FILE_TYPE:
        case CLOUDINARY_GIF_FILE_TYPE:
            return CLOUDINARY_IMAGE_PREFIX;
        case CLOUDINARY_VIDEO_FILE_TYPE:
        case CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE:
            return CLOUDINARY_VIDEO_PREFIX;
        default:
            return CLOUDINARY_IMAGE_PREFIX;
    }
};
var getImageTransformation = function(assetQuality) {
    return "f_auto,".concat(assetQuality);
};
var getVideoTransformation = function(assetQuality) {
    return "".concat(assetQuality, ",f_auto,cs_copy");
}; // reversed the order to clear cache with monday 2.0 video issue
var getTransformation = function(param) {
    var fileType = param.fileType, assetQuality = param.assetQuality;
    assetQuality = assetQuality || _cloudinaryAssetQualities.AUTO;
    switch(fileType){
        case CLOUDINARY_IMAGE_FILE_TYPE:
            return getImageTransformation(assetQuality);
        case CLOUDINARY_VIDEO_FILE_TYPE:
            return getVideoTransformation(assetQuality);
        case CLOUDINARY_GIF_FILE_TYPE:
            return GIF_TO_VIDEO_AUTO_TRANSFORMATION;
        case CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE:
            return VIDEO_THUMBNAIL_TRANSFORMATION;
        default:
            return getImageTransformation(assetQuality);
    }
};
var getPresets = function(transformation, preset) {
    if (!preset) return transformation;
    var transformations = [
        transformation
    ];
    PresetKeysConvertionKey.forEach(function(key) {
        if (preset[key]) {
            transformations.push("".concat(PresetKeysConvertion[key]).concat(preset[key]));
        }
    });
    return transformations.join(",");
};
var generateCloudinaryUrl = function(fileType, publicId, isFetch, preset) {
    var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var assetQuality = options.assetQuality;
    var prefix = getPrefix(fileType);
    var postfix = getCloudinaryMethodPostfix(isFetch);
    var transformation = getTransformation({
        fileType: fileType,
        assetQuality: assetQuality
    });
    var presets = getPresets(transformation, preset);
    var cloudinaryUrl = "".concat(prefix).concat(postfix).concat(presets, "/").concat(publicId);
    return cloudinaryUrl;
};
var extractWidthTransformationIfNeeded = function(props, cloudinaryTransformations) {
    var width = props.width;
    if (!width) return cloudinaryTransformations;
    if (typeof width === "number") {
        cloudinaryTransformations.width = width;
    } else if (typeof width === "string" && width.indexOf("px") > -1) {
        cloudinaryTransformations.width = parseInt(width);
    }
    return cloudinaryTransformations;
};
var extractCloudinaryTransformations = function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var cloudinaryTransformations = {};
    cloudinaryTransformations = extractWidthTransformationIfNeeded(props, cloudinaryTransformations);
    return cloudinaryTransformations;
};
var generateCloudinaryImageUrl = function(src) {
    var cloudinaryTransformations = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var fixedSrc = addBasePathToUrl(src);
    var ref = extractPublicId(fixedSrc), isFetch = ref.isFetch, publicId = ref.publicId;
    return generateCloudinaryUrl(CLOUDINARY_IMAGE_FILE_TYPE, publicId, isFetch, cloudinaryTransformations, options);
};
var getCloudinaryUrlSrc = function(src) {
    return isCloudinaryUrl(src) ? src : generateCloudinaryImageUrl(src);
};
var generateCloudinaryVideoThumbnail = function(videoSrc) {
    var fixedSrc = addBasePathToUrl(videoSrc);
    var fileWithImageExtension = replaceFileExtension(fixedSrc, JPG_FILE_EXTENSION);
    var ref = extractPublicId(fileWithImageExtension), isFetch = ref.isFetch, publicId = ref.publicId;
    return generateCloudinaryUrl(CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE, publicId, isFetch, null);
};
var generateCloudinaryVideoThumbnailFromFullUrl = function(fullVideoUrl) {
    var urlWithTransformation = fullVideoUrl.replace("/video/upload/", "/video/upload/so_0p/");
    return urlWithTransformation.replace(/\.[^.]+$/, ".".concat(JPG_FILE_EXTENSION));
};
var generateCloudinaryVideoUrl = function(src) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fixedSrc = addBasePathToUrl(src);
    var ref = extractPublicId(fixedSrc), isFetch = ref.isFetch, publicId = ref.publicId;
    var fileType = getFileExtension(src) === GIF_FILE_EXTENSION ? CLOUDINARY_GIF_FILE_TYPE : CLOUDINARY_VIDEO_FILE_TYPE;
    return generateCloudinaryUrl(fileType, publicId, isFetch, null, options);
};
var getPropValueFromCloudinaryUrl = function(cloudinaryFullUrl) {
    if (!cloudinaryFullUrl) return;
    var cloudinaryDecodedUrl = decodeURIComponent(cloudinaryFullUrl);
    var staticFolderPrefix = cloudinaryDecodedUrl.indexOf(CLOUDINARY_STATIC_FOLDER);
    if (staticFolderPrefix > -1) {
        var splitStr = cloudinaryDecodedUrl.substring(staticFolderPrefix + CLOUDINARY_STATIC_FOLDER.length);
        return "".concat(CLOUDINARY_STATIC_FOLDER_NAME).concat(splitStr);
    }
    var featuredImagesFolderPrefix = cloudinaryDecodedUrl.indexOf(GENERATOR_FEATURED_IMAGES_FOLDER);
    if (featuredImagesFolderPrefix > -1) {
        return "/".concat(cloudinaryDecodedUrl.substring(featuredImagesFolderPrefix));
    }
    return cloudinaryFullUrl;
};
var getFolderValueFromCloudinaryUrl = function(cloudinaryFullUrl) {
    if (!cloudinaryFullUrl) return;
    var cloudinaryDecodedUrl = decodeURIComponent(cloudinaryFullUrl).replace("http:", "https:");
    var prefixUrl = "".concat(CLOUDINARY_BASE, "image/upload/");
    var relativeUrl = cloudinaryDecodedUrl.indexOf(prefixUrl);
    if (relativeUrl > -1) {
        var relativeFolder = cloudinaryDecodedUrl.substring(prefixUrl.length, cloudinaryDecodedUrl.lastIndexOf("/"));
        return relativeFolder.substring(relativeFolder.indexOf("/") + 1, relativeFolder.length); // remove the v[number] folder path
    }
    return null;
};
var getCloudinaryMediaLibraryAuthenticationAccess = function() {
    var _ref = _async_to_generator(function() {
        var get, ref, CLOUDINARY_API_KEY, CLOUDINARY_API_SECRET, timeStamp, userName, authString, signature, apiKey;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    get = (__webpack_require__(61217).get);
                    return [
                        4,
                        get("cloudinary")
                    ];
                case 1:
                    ref = _state.sent(), CLOUDINARY_API_KEY = ref.api_key, CLOUDINARY_API_SECRET = ref.api_secret;
                    timeStamp = Math.round(new Date().getTime() / 1000);
                    userName = CLOUDINARY_MEDIA_LIBRARY_USER_NAME;
                    authString = "cloud_name=".concat(CLOUDINARY_CLOUD_NAME, "&timestamp=").concat(timeStamp, "&username=").concat(userName).concat(CLOUDINARY_API_SECRET);
                    signature = SHA256(authString).toString();
                    apiKey = CLOUDINARY_API_KEY;
                    return [
                        2,
                        {
                            timeStamp: timeStamp,
                            signature: signature,
                            userName: userName,
                            apiKey: apiKey
                        }
                    ];
            }
        });
    });
    return function getCloudinaryMediaLibraryAuthenticationAccess() {
        return _ref.apply(this, arguments);
    };
}();
var getMediaLibraryCreationConfig = function(cloudinaryAuthentication) {
    return {
        cloud_name: CLOUDINARY_CLOUD_NAME,
        api_key: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.apiKey,
        username: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.userName,
        insert_caption: "Select",
        timestamp: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.timeStamp,
        signature: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.signature,
        multiple: false
    };
};
var isCloudinaryUrl = function(url) {
    return (url === null || url === void 0 ? void 0 : url.indexOf(CLOUDINARY_BASE)) === 0 || (url === null || url === void 0 ? void 0 : url.indexOf(CLOUDINARY_UNSECURE_BASE)) === 0;
};
var getColorTransformation = function(color) {
    if (!color) return null;
    // if color doesn't start with a pound sign (although should) -
    // return an empty string that would not affect the Cloudinary url
    if (color.charAt(0) !== "#") {
        return null;
    }
    // remove pound sound from color
    var colorWithNoPoundSign = color.substring(1);
    return "e_colorize,co_rgb:".concat(colorWithNoPoundSign, "/");
};
/* DON'T USE THIS FUNCTION
 * It's currently used for a specific use case, and will be fixed later so it can be used by any component
 * */ var getUrlWithColor = function(param) {
    var url = param.url, color = param.color;
    var cloudinaryDecodedUrl = decodeURIComponent(url);
    var colorString = getColorTransformation(color);
    // if failed to create the color transformation
    if (!colorString) {
        return url;
    }
    var insertPosition = cloudinaryDecodedUrl.indexOf(GENERATOR_FEATURED_IMAGES_FOLDER);
    var urlWithColor = [
        cloudinaryDecodedUrl.slice(0, insertPosition),
        colorString,
        cloudinaryDecodedUrl.slice(insertPosition)
    ].join("");
    return urlWithColor;
};
module.exports = {
    CLOUDINARY_CLOUD_NAME: CLOUDINARY_CLOUD_NAME,
    LOW_RES_IMAGE_QUALITY_LEVEL: LOW_RES_IMAGE_QUALITY_LEVEL,
    IMAGE_DEFAULT_BLUR: IMAGE_DEFAULT_BLUR,
    CLOUDINARY_IMAGE_FILE_TYPE: CLOUDINARY_IMAGE_FILE_TYPE,
    PresetTransformations: PresetTransformations,
    extractPublicId: extractPublicId,
    generateCloudinaryUrl: generateCloudinaryUrl,
    generateCloudinaryImageUrl: generateCloudinaryImageUrl,
    generateCloudinaryVideoUrl: generateCloudinaryVideoUrl,
    generateCloudinaryRawUrl: generateCloudinaryRawUrl,
    generateCloudinaryVideoThumbnail: generateCloudinaryVideoThumbnail,
    extractCloudinaryTransformations: extractCloudinaryTransformations,
    CLOUDINARY_STATIC_FOLDER: CLOUDINARY_STATIC_FOLDER,
    CLOUDINARY_BASE_VIDEO_URL: CLOUDINARY_BASE_VIDEO_URL,
    CLOUDINARY_IMAGE_UPLOADS_BASE_FOLDER: CLOUDINARY_IMAGE_UPLOADS_BASE_FOLDER,
    getPropValueFromCloudinaryUrl: getPropValueFromCloudinaryUrl,
    getFolderValueFromCloudinaryUrl: getFolderValueFromCloudinaryUrl,
    getCloudinaryMediaLibraryAuthenticationAccess: getCloudinaryMediaLibraryAuthenticationAccess,
    CLOUDINARY_MEDIA_LIBRARY_SCRIPT: CLOUDINARY_MEDIA_LIBRARY_SCRIPT,
    CLOUDINARY_VIDEO_RESOURCE: CLOUDINARY_VIDEO_RESOURCE,
    CLOUDINARY_IMAGE_RESOURCE: CLOUDINARY_IMAGE_RESOURCE,
    getMediaLibraryCreationConfig: getMediaLibraryCreationConfig,
    isCloudinaryUrl: isCloudinaryUrl,
    CLOUDINARY_IMAGE_PREFIX: CLOUDINARY_IMAGE_PREFIX,
    FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM: FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM,
    getCloudinaryUrlSrc: getCloudinaryUrlSrc,
    getUrlWithColor: getUrlWithColor,
    generateCloudinaryVideoThumbnailFromFullUrl: generateCloudinaryVideoThumbnailFromFullUrl
};


/***/ }),

/***/ 932:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);

var COMMUNITY_URL_PREFIX = "";
var isDevelopment = process.env.ENV == "DEV";
var MONDAY_STORIES_SLUG_URL = "https://mondaystories.monday.com";
var getTemplateUrl = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/show/").concat(templateId);
};
var getTemplateUrlWithNextTemplates = function(templateId, nextTemplatesIds) {
    if (!templateId) {
        return null;
    }
    if (!nextTemplatesIds || nextTemplatesIds.length == 0) {
        return getTemplateUrl(templateId);
    }
    return "".concat(getTemplateUrl(templateId), "?next=").concat(nextTemplatesIds.join());
};
var getTemplateEditUrl = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/edit/").concat(templateId);
};
var getTemplateEditSelfie = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/edit-selfie/").concat(templateId);
};
var getTemplateEditBoardScreenshot = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/edit-board-screenshot/").concat(templateId);
};
var getUserTemplatesUrl = function(userId) {
    if (!userId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/user/").concat(userId);
};
var getAccountTemplatesUrl = function(accountId) {
    if (!accountId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/account/").concat(accountId);
};
var getAdminPageUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/admin");
};
var getTop5CategoryPageUrl = function(category) {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/top5/").concat(category);
};
var getShareNewTemplateUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/new");
};
var getUserPagesUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/user/pages");
};
var getUserApprovalPageUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/user/approval");
};
var isUserPagesUrl = function(url) {
    return url && url.endsWith("/stories/user/pages");
};
var fixDevImageUrl = function(src) {
    if (isDevelopment && src && (src.startsWith("/static/") || src.startsWith("/Generator_featured images"))) {
        // in local host - change the source url to mondaystaging.com
        src = "https://mondaystaging.com" + src;
    }
    return src;
};
var addBasePathToUrl = function(src) {
    src = fixDevImageUrl(src);
    if (src && !src.startsWith("http")) {
        src = "".concat("https://monday.com").concat(src);
    }
    return src;
};
var getIntercomConversationUrl = function(appId, userId) {
    return "https://app.intercom.io/a/apps/".concat(appId, "/users/").concat(userId, "/all-conversations");
};
var getMondayStoriesBoardUrl = function(boardId) {
    return "".concat(MONDAY_STORIES_SLUG_URL, "/boards/").concat(boardId);
};
var getMondayStoriesEmbeddedBoardUrl = function(boardId) {
    return "".concat(MONDAY_STORIES_SLUG_URL, "/embedded_boards_json/").concat(boardId, "?clean-board=true&allow-edit=true");
};
var getMondayBoardUrl = function(boardId, slug) {
    return "".concat(MONDAY_STORIES_SLUG_URL.replace("mondaystories", slug), "/boards/").concat(boardId);
};
var getSlugUseTemplateUrl = function(slug) {
    return MONDAY_STORIES_SLUG_URL.replace("mondaystories", slug) + "/stories/board_from_story";
};
var getHomeUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories");
};
var getLoginUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/authentication/signin");
};
var getSignupUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/signup");
};
var getLandingPageWithoutAutoLoginUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/u_landing");
};
module.exports = {
    getTemplateUrl: getTemplateUrl,
    getTemplateUrlWithNextTemplates: getTemplateUrlWithNextTemplates,
    getTemplateEditUrl: getTemplateEditUrl,
    getUserTemplatesUrl: getUserTemplatesUrl,
    getUserApprovalPageUrl: getUserApprovalPageUrl,
    getAccountTemplatesUrl: getAccountTemplatesUrl,
    getAdminPageUrl: getAdminPageUrl,
    fixDevImageUrl: fixDevImageUrl,
    getShareNewTemplateUrl: getShareNewTemplateUrl,
    getUserPagesUrl: getUserPagesUrl,
    isUserPagesUrl: isUserPagesUrl,
    getTemplateEditSelfie: getTemplateEditSelfie,
    getTemplateEditBoardScreenshot: getTemplateEditBoardScreenshot,
    getIntercomConversationUrl: getIntercomConversationUrl,
    getMondayStoriesBoardUrl: getMondayStoriesBoardUrl,
    getMondayBoardUrl: getMondayBoardUrl,
    getMondayStoriesEmbeddedBoardUrl: getMondayStoriesEmbeddedBoardUrl,
    getSlugUseTemplateUrl: getSlugUseTemplateUrl,
    getHomeUrl: getHomeUrl,
    getLoginUrl: getLoginUrl,
    getSignupUrl: getSignupUrl,
    getLandingPageWithoutAutoLoginUrl: getLandingPageWithoutAutoLoginUrl,
    getTop5CategoryPageUrl: getTop5CategoryPageUrl,
    addBasePathToUrl: addBasePathToUrl
};


/***/ }),

/***/ 85010:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var countriesList = __webpack_require__(53590);
// COUNTRY CODES
var CANADA_ISO2 = "CA";
var ISRAEL_ISO2 = "IL";
var UNITED_STATES_ISO2 = "US";
var MEXICO_ISO2 = "MX";
var SPAIN_ISO2 = "ES";
var PORTUGAL_ISO2 = "PT";
var CHILE_ISO2 = "CL";
var PERO_ISO2 = "PE";
var ARGENTINA_ISO2 = "AR";
var BRAZIL_ISO2 = "BR";
var FRANCE_ISO2 = "FR";
var BELGIUM_ISO2 = "BE";
var GERMANY_ISO2 = "DE";
var AUSTRIA_ISO2 = "AT";
var SWITZERLAND_ISO2 = "CH";
var NETHERLANDS_ISO2 = "NL";
var ITALY_ISO2 = "IT";
var RUSSIA_ISO2 = "RU";
var JAPAN_ISO2 = "JP";
var KOREA_ISO2 = "KO";
var TURKEY_ISO2 = "TR";
var SWEDEN_ISO2 = "SE";
var BULGARIA_ISO2 = "BG";
var NORWAY_ISO2 = "NO";
var DENMARK_ISO2 = "DK";
var POLAND_ISO2 = "PL";
var LUXEMBOURG_ISO2 = "LU";
var HONG_KONG_ISO2 = "HK";
var ICELAND_ISO2 = "IS";
var TAIWAN_ISO2 = "TW";
var AUSTRALIA_ISO2 = "AU";
var UNITED_KINGDOM_ISO2 = "GB";
var IRELAND_ISO2 = "IE";
var SAUDI_ARABIA_ISO2 = "SA";
var NEW_ZEALAND_ISO2 = "NZ";
var COSTA_RICA_ISO2 = "CR";
var EL_SALVADOR_ISO2 = "SV";
var GUATEMALA_ISO2 = "GT";
var HONDURAS_ISO2 = "HN";
var NICARAGUA_ISO2 = "NI";
var PANAMA_ISO2 = "PA";
var CUBA_ISO2 = "CU";
var DOMINICAN_REPUBLIC_ISO2 = "DO";
var PUERTO_RICO_ISO2 = "PR";
var BOLIVIA_ISO2 = "BO";
var COLUMBIA_ISO2 = "CO";
var ECUADOR_ISO2 = "EC";
var PARAGUAY_ISO2 = "PY";
var PERU_ISO2 = "PE";
var URUGUAY_ISO2 = "UY";
var VENEZUELA_ISO2 = "VE";
var EQUATORIAL_GUINEA_ISO2 = "GQ";
var FINLAND_ISO2 = "FI";
var ARMENIA_ISO2 = "AM";
var AZERBAIJAN_ISO2 = "AZ";
var BAHRAIN_ISO2 = "BH";
var BELARUS_ISO2 = "BY";
var CROATIA_ISO2 = "HR";
var CYPRUS_ISO2 = "CY";
var CZECHIA_ISO2 = "CZ";
var EGYPT_ISO2 = "EG";
var ESTONIA_ISO2 = "EE";
var GEORGIA_ISO2 = "GE";
var GREECE_ISO2 = "GR";
var HUNGARY_ISO2 = "HU";
var KAZAKHSTAN_ISO2 = "KZ";
var KENYA_ISO2 = "KE";
var KUWAIT_ISO2 = "KW";
var LATVIA_ISO2 = "LV";
var LITHUANIA_ISO2 = "LT";
var MAURITIUS_ISO2 = "MU";
var MOZAMBIQUE_ISO2 = "MZ";
var NIGERIA_ISO2 = "NG";
var OMAN_ISO2 = "OM";
var PHILIPPINES_ISO2 = "PH";
var QATAR_ISO2 = "QA";
var ROMANIA_ISO2 = "RO";
var RWANDA_ISO2 = "RW";
var SINGAPORE_ISO2 = "SG";
var SLOVAKIA_ISO2 = "SK";
var SLOVENIA_ISO2 = "SL";
var SOUTH_AFRICA_ISO2 = "ZA";
var SOUTH_SUDAN_ISO2 = "SS";
var TANZANIA_ISO2 = "TZ";
var UGANDA_ISO2 = "UG";
var UKRAINE_ISO2 = "UA";
var UNITED_ARAB_EMIRATES_ISO2 = "AE";
var UZBEKISTAN_ISO2 = "UZ";
var AMERICAN_SAMOA_ISO2 = "AS";
var GUAM_ISO2 = "GU";
var NORTHERN_MARIANA_ISLANDS_ISO2 = "MP";
var UNITED_STATES_MINOR_OUTLYING_ISLANDS_ISO2 = "UM";
var MAIN_COUNTRY_CODES = {
    CANADA_ISO2: CANADA_ISO2,
    ISRAEL_ISO2: ISRAEL_ISO2,
    UNITED_STATES_ISO2: UNITED_STATES_ISO2,
    MEXICO_ISO2: MEXICO_ISO2,
    SPAIN_ISO2: SPAIN_ISO2,
    PORTUGAL_ISO2: PORTUGAL_ISO2,
    CHILE_ISO2: CHILE_ISO2,
    PERO_ISO2: PERO_ISO2,
    ARGENTINA_ISO2: ARGENTINA_ISO2,
    BRAZIL_ISO2: BRAZIL_ISO2,
    FRANCE_ISO2: FRANCE_ISO2,
    BELGIUM_ISO2: BELGIUM_ISO2,
    GERMANY_ISO2: GERMANY_ISO2,
    AUSTRIA_ISO2: AUSTRIA_ISO2,
    SWITZERLAND_ISO2: SWITZERLAND_ISO2,
    NETHERLANDS_ISO2: NETHERLANDS_ISO2,
    ITALY_ISO2: ITALY_ISO2,
    RUSSIA_ISO2: RUSSIA_ISO2,
    JAPAN_ISO2: JAPAN_ISO2,
    KOREA_ISO2: KOREA_ISO2,
    TURKEY_ISO2: TURKEY_ISO2,
    SWEDEN_ISO2: SWEDEN_ISO2,
    BULGARIA_ISO2: BULGARIA_ISO2,
    NORWAY_ISO2: NORWAY_ISO2,
    DENMARK_ISO2: DENMARK_ISO2,
    POLAND_ISO2: POLAND_ISO2,
    LUXEMBOURG_ISO2: LUXEMBOURG_ISO2,
    HONG_KONG_ISO2: HONG_KONG_ISO2,
    ICELAND_ISO2: ICELAND_ISO2,
    TAIWAN_ISO2: TAIWAN_ISO2,
    AUSTRALIA_ISO2: AUSTRALIA_ISO2,
    UNITED_KINGDOM_ISO2: UNITED_KINGDOM_ISO2,
    IRELAND_ISO2: IRELAND_ISO2,
    SAUDI_ARABIA_ISO2: SAUDI_ARABIA_ISO2,
    NEW_ZEALAND_ISO2: NEW_ZEALAND_ISO2,
    COSTA_RICA_ISO2: COSTA_RICA_ISO2,
    EL_SALVADOR_ISO2: EL_SALVADOR_ISO2,
    GUATEMALA_ISO2: GUATEMALA_ISO2,
    HONDURAS_ISO2: HONDURAS_ISO2,
    NICARAGUA_ISO2: NICARAGUA_ISO2,
    PANAMA_ISO2: PANAMA_ISO2,
    CUBA_ISO2: CUBA_ISO2,
    DOMINICAN_REPUBLIC_ISO2: DOMINICAN_REPUBLIC_ISO2,
    PUERTO_RICO_ISO2: PUERTO_RICO_ISO2,
    BOLIVIA_ISO2: BOLIVIA_ISO2,
    COLUMBIA_ISO2: COLUMBIA_ISO2,
    ECUADOR_ISO2: ECUADOR_ISO2,
    PARAGUAY_ISO2: PARAGUAY_ISO2,
    PERU_ISO2: PERU_ISO2,
    URUGUAY_ISO2: URUGUAY_ISO2,
    VENEZUELA_ISO2: VENEZUELA_ISO2,
    EQUATORIAL_GUINEA_ISO2: EQUATORIAL_GUINEA_ISO2,
    FINLAND_ISO2: FINLAND_ISO2,
    ARMENIA_ISO2: ARMENIA_ISO2,
    AZERBAIJAN_ISO2: AZERBAIJAN_ISO2,
    BAHRAIN_ISO2: BAHRAIN_ISO2,
    BELARUS_ISO2: BELARUS_ISO2,
    CROATIA_ISO2: CROATIA_ISO2,
    CYPRUS_ISO2: CYPRUS_ISO2,
    CZECHIA_ISO2: CZECHIA_ISO2,
    EGYPT_ISO2: EGYPT_ISO2,
    ESTONIA_ISO2: ESTONIA_ISO2,
    GEORGIA_ISO2: GEORGIA_ISO2,
    GREECE_ISO2: GREECE_ISO2,
    HUNGARY_ISO2: HUNGARY_ISO2,
    KAZAKHSTAN_ISO2: KAZAKHSTAN_ISO2,
    KENYA_ISO2: KENYA_ISO2,
    KUWAIT_ISO2: KUWAIT_ISO2,
    LATVIA_ISO2: LATVIA_ISO2,
    LITHUANIA_ISO2: LITHUANIA_ISO2,
    MAURITIUS_ISO2: MAURITIUS_ISO2,
    MOZAMBIQUE_ISO2: MOZAMBIQUE_ISO2,
    NIGERIA_ISO2: NIGERIA_ISO2,
    OMAN_ISO2: OMAN_ISO2,
    QATAR_ISO2: QATAR_ISO2,
    ROMANIA_ISO2: ROMANIA_ISO2,
    RWANDA_ISO2: RWANDA_ISO2,
    SLOVAKIA_ISO2: SLOVAKIA_ISO2,
    SLOVENIA_ISO2: SLOVENIA_ISO2,
    SOUTH_AFRICA_ISO2: SOUTH_AFRICA_ISO2,
    SOUTH_SUDAN_ISO2: SOUTH_SUDAN_ISO2,
    TANZANIA_ISO2: TANZANIA_ISO2,
    UGANDA_ISO2: UGANDA_ISO2,
    UKRAINE_ISO2: UKRAINE_ISO2,
    UNITED_ARAB_EMIRATES_ISO2: UNITED_ARAB_EMIRATES_ISO2,
    UZBEKISTAN_ISO2: UZBEKISTAN_ISO2
};
var NON_NATIVE_ENGLISH_COUNTRIES_ISO2 = [
    MEXICO_ISO2,
    SPAIN_ISO2,
    CHILE_ISO2,
    PERO_ISO2,
    ARGENTINA_ISO2,
    BRAZIL_ISO2,
    FRANCE_ISO2,
    CANADA_ISO2,
    BELGIUM_ISO2,
    GERMANY_ISO2,
    AUSTRIA_ISO2,
    SWITZERLAND_ISO2,
    NETHERLANDS_ISO2,
    ITALY_ISO2,
    RUSSIA_ISO2,
    JAPAN_ISO2,
    KOREA_ISO2,
    TURKEY_ISO2,
    SWEDEN_ISO2,
    POLAND_ISO2,
    HONG_KONG_ISO2,
    TAIWAN_ISO2
];
// CONTINENT CODES
var OCEANIA = "OC"; // Australia, New Zealand + surrounding islands and countries
var EUROPE = "EU";
var NORTH_AMERICA = "NA";
// Special list of countries - US territories in the Oceania continent
var US_OCEANIC_TERRITORIES = [
    AMERICAN_SAMOA_ISO2,
    GUAM_ISO2,
    NORTHERN_MARIANA_ISLANDS_ISO2,
    UNITED_STATES_MINOR_OUTLYING_ISLANDS_ISO2
];
var getCountriesByContinent = function(continentCode) {
    var countries = countriesList.countries;
    var countryCodes = Object.keys(countries);
    return countryCodes.filter(function(cc) {
        return countries[cc].continent === continentCode;
    });
};
var isCountryInContinent = function(countryCode, continentCode) {
    return getCountriesByContinent(continentCode).includes(countryCode);
};
var getContientByCountry = function(countryCode) {
    var _countries_countryCode;
    var countries = countriesList.countries;
    return (_countries_countryCode = countries[countryCode]) === null || _countries_countryCode === void 0 ? void 0 : _countries_countryCode.continent;
};
var COUNTRIES_DROPDOWN_OPTIONS = [
    {
        value: MAIN_COUNTRY_CODES.ISRAEL_ISO2,
        text: "Israel"
    },
    {
        value: MAIN_COUNTRY_CODES.UNITED_STATES_ISO2,
        text: "United States"
    },
    {
        value: MAIN_COUNTRY_CODES.AUSTRALIA_ISO2,
        text: "Australia"
    },
    {
        value: MAIN_COUNTRY_CODES.UNITED_KINGDOM_ISO2,
        text: "United Kingdom"
    },
    {
        value: MAIN_COUNTRY_CODES.PHILIPPINES_ISO2,
        text: "Philippines"
    },
    {
        value: MAIN_COUNTRY_CODES.SINGAPORE_ISO2,
        text: "Singapore"
    },
    {
        value: MAIN_COUNTRY_CODES.CANADA_ISO2,
        text: "Canada"
    }
];
module.exports = {
    // COUNTRIES ISO2
    MAIN_COUNTRY_CODES: MAIN_COUNTRY_CODES,
    CANADA_ISO2: CANADA_ISO2,
    UNITED_STATES_ISO2: UNITED_STATES_ISO2,
    UNITED_KINGDOM_ISO2: UNITED_KINGDOM_ISO2,
    AUSTRALIA_ISO2: AUSTRALIA_ISO2,
    ISRAEL_ISO2: ISRAEL_ISO2,
    NON_NATIVE_ENGLISH_COUNTRIES_ISO2: NON_NATIVE_ENGLISH_COUNTRIES_ISO2,
    BRAZIL_ISO2: BRAZIL_ISO2,
    SPAIN_ISO2: SPAIN_ISO2,
    PORTUGAL_ISO2: PORTUGAL_ISO2,
    PHILIPPINES_ISO2: PHILIPPINES_ISO2,
    SINGAPORE_ISO2: SINGAPORE_ISO2,
    US_OCEANIC_TERRITORIES: US_OCEANIC_TERRITORIES,
    // CONTINENTS
    OCEANIA: OCEANIA,
    EUROPE: EUROPE,
    NORTH_AMERICA: NORTH_AMERICA,
    COUNTRIES_DROPDOWN_OPTIONS: COUNTRIES_DROPDOWN_OPTIONS,
    // FUNCTIONS
    getCountriesByContinent: getCountriesByContinent,
    isCountryInContinent: isCountryInContinent,
    getContientByCountry: getContientByCountry
};


/***/ }),

/***/ 56274:
/***/ (function(module) {

"use strict";

var TESTING_ENV = "test";
var isDevelopment = "production" === "development";
var isTesting = "production" === TESTING_ENV;
module.exports = {
    isDevelopment: isDevelopment,
    isTesting: isTesting
};


/***/ }),

/***/ 41871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var getCookie = (__webpack_require__(47041).getCookie);
var isDevelopment = (__webpack_require__(56274).isDevelopment);
var isRunningInClient = (__webpack_require__(44566).isRunningInClient);
var AB_TEST_VARIANTS_HEADER = "x-abtest-variants";
var getHasFreeTier = (__webpack_require__(83070).getHasFreeTier);
var getHasStudentPlan = (__webpack_require__(61418).getHasStudentPlan);
var ref = __webpack_require__(13019), HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME = ref.HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME, HAS_FREE_TIER_INDICATION_COOKIE_NAME = ref.HAS_FREE_TIER_INDICATION_COOKIE_NAME;
var ref1 = __webpack_require__(54224), FORCE_PRICING = ref1.FORCE_PRICING, PREVENT_FREE_TIER_PARAM = ref1.PREVENT_FREE_TIER_PARAM;
var SYNTHETIC_TEST_COOKIE_NAME = (__webpack_require__(13019).SYNTHETIC_TEST_COOKIE_NAME);
var getBigBrainEventSentVarName = function(testName) {
    return "bb_event_sent_ab_test_".concat(testName);
};
var testEventSent = function(testName) {
    var eventSentVar = getBigBrainEventSentVarName(testName);
    return !!window[eventSentVar];
};
var setTestEventSent = function(testName) {
    var eventSentVar = getBigBrainEventSentVarName(testName);
    window[eventSentVar] = true;
};
var setHotjarTestVariant = function(testName, testVariant) {
    if (!isRunningInClient) return;
    if (window && !window.hj || !testVariant) return;
    if (window.path !== "/") return; // temp specific code to record only homepage
    var tag = "".concat(testName, "-").concat(testVariant);
    window.hj("trigger", "".concat(tag));
};
// if called in the client, req and res will be undefined.
// This is ok in the case we just want to avoid sending the BigBrain event
// in synthetic tests and this is only relevant for client.
var shouldSkipEnteringTest = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var req = options.req, res = options.res;
    // Synthetic test - skip entering AB test
    return !!getCookie(SYNTHETIC_TEST_COOKIE_NAME, {
        req: req,
        res: res
    });
};
var sendAbTestEvent = function(testName, variant) {
    var extraParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (isRunningInClient() && !testEventSent(testName)) {
        var trackEvent = (__webpack_require__(65488).trackEvent);
        trackEvent(testName, _object_spread({
            ab_test: variant
        }, extraParams));
        setTestEventSent(testName);
    }
};
// can be used both in Server and Clients side render - event sent only when in client
var getAbTestVariantNew = function(allAbTests, testName) {
    var sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, sendHotjarEvent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, extraBigBrainParams = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    if (isRunningInClient() && shouldSkipEnteringTest()) return null;
    var test = allAbTests.find(function(abTest) {
        return abTest.name === testName;
    });
    if (!test) return null;
    if (sendBigBrainEvent) {
        sendAbTestEvent(testName, test.variant, extraBigBrainParams);
        if (sendHotjarEvent) setHotjarTestVariant(testName, test.variant);
    }
    return test.variant;
};
var fireEventsOnServerRedirectTests = function(allAbTests) {
// THIS FUNCTION IS USED TO SEND BIG BRAIN EVENT WHEN RUNNING SERVER REDIRECT TESTS
// CREATE AN ABTEST WITH exact_pages that include only the original and redirect page and then call:
// getAbTestVariantNew(allAbTests, TEST_NAME, true);
};
var isInTestWithNewVariant = function(abTestData) {
    var abTests = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getAbTestVariantNew(abTests, abTestData.test_name, sendBigBrainEvent) === abTestData.new_variation_name;
};
var isInTestWithOldVariant = function(abTestData) {
    var abTests = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getAbTestVariantNew(abTests, abTestData.test_name, sendBigBrainEvent) === abTestData.old_variation_name;
};
var isInTest = function(abTestData) {
    var abTests = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return !!getAbTestVariantNew(abTests, abTestData.test_name, sendBigBrainEvent);
};
var getHasFreeTierByRequest = function(req) {
    if (!req) return false;
    var path = req.path;
    var freeTierForcePrevent = req.query && req.query[PREVENT_FREE_TIER_PARAM];
    var forcePricing = req.query && req.query[FORCE_PRICING];
    var hasFreeTierCookie = req.cookies[HAS_FREE_TIER_INDICATION_COOKIE_NAME];
    var hasStudentPlanCookie = req.cookies[HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME];
    var hasStudentPlan = getHasStudentPlan({
        forcePricing: forcePricing,
        hasStudentPlanCookie: hasStudentPlanCookie
    });
    return getHasFreeTier({
        asPath: path,
        freeTierForcePrevent: freeTierForcePrevent,
        hasStudentPlan: hasStudentPlan,
        hasFreeTierCookie: hasFreeTierCookie
    });
};
var DEV_AB_TESTS = [
    {
        name: "crm_pricing_page_sections_test",
        variant: "new_with_crm_sections"
    },
    {
        name: "contact_sales_submit_notice_ab_test",
        variant: "new_with_submit_notice"
    },
    {
        name: "keep_region_au_ab_test",
        variant: "new_with_keep_region"
    },
    {
        name: "contact_sales_typeform_emea",
        variant: "new_with_typeform"
    },
    {
        name: "contact_sales_typeform_anz",
        variant: "new_with_typeform"
    },
    {
        name: "header_new_products_offering_more_clickable_test",
        variant: "old_header_products_offering"
    },
    {
        name: "pricing_page_sub_title_v2_ab_test",
        variant: "new_pricing_with_sub_title_v2"
    },
    {
        name: "unlimited_time_free_plan_cta_text_test",
        variant: "new_unlimited_time_cta"
    },
    {
        name: "homepage_pricing_enterprise_contact_us_typeform_feature_flag",
        variant: "new_homepage_pricing_enterprise_contact_us_typeform_feature_flag"
    }
];
var getAbTestsFromRequest = function(req) {
    if (isDevelopment) return JSON.stringify(DEV_AB_TESTS);
    return req.headers[AB_TEST_VARIANTS_HEADER];
};
var getAllAbTestsVariantsFromRequest = function(req) {
    var abTestsHeader = req && getAbTestsFromRequest(req);
    if (abTestsHeader) {
        try {
            return JSON.parse(abTestsHeader);
        } catch (err) {
            console.error("Error Parsing AB Test Header string:", abTestsHeader, " with error: ", err);
            return [];
        }
    } else {
        return [];
    }
};
module.exports = {
    getAbTestVariantNew: getAbTestVariantNew,
    sendAbTestEvent: sendAbTestEvent,
    fireEventsOnServerRedirectTests: fireEventsOnServerRedirectTests,
    getAllAbTestsVariantsFromRequest: getAllAbTestsVariantsFromRequest,
    isInTest: isInTest,
    isInTestWithNewVariant: isInTestWithNewVariant,
    isInTestWithOldVariant: isInTestWithOldVariant,
    getHasFreeTierByRequest: getHasFreeTierByRequest,
    shouldSkipEnteringTest: shouldSkipEnteringTest
};


/***/ }),

/***/ 83070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var URL_PREFIXES = (__webpack_require__(16612).URL_PREFIXES);
var startsWith = __webpack_require__(10240);
var getHasFreeTier = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var freeTierForcePrevent = options.freeTierForcePrevent, asPath = options.asPath, hasFreeTierCookie = options.hasFreeTierCookie, hasStudentPlan = options.hasStudentPlan;
    // QS to prevent free tier
    if (freeTierForcePrevent) return false;
    // Student plan is private case of free tier
    if (hasStudentPlan) return true;
    // Free tier landing pages start with /ft/. we want to force free tier for them.
    if (asPath && startsWith(asPath, URL_PREFIXES.FREE_TIER)) return true;
    // Platform indication.
    if (hasFreeTierCookie) return hasFreeTierCookie === "true";
    return true;
};
module.exports = {
    getHasFreeTier: getHasFreeTier
};


/***/ }),

/***/ 61418:
/***/ (function(module) {

"use strict";

var getHasStudentPlan = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var forcePricing = options.forcePricing, hasStudentPlanCookie = options.hasStudentPlanCookie;
    // Enable us to force the student plan by query param.
    if (forcePricing === "student_plan") return true;
    // Platform indication.
    return hasStudentPlanCookie === "true";
};
module.exports = {
    getHasStudentPlan: getHasStudentPlan
};


/***/ }),

/***/ 20618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Returns the objects that leftArr contains and rightArr doesn't (i.e. leftArr - rightArr )

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
var getArraysDifference = function(leftArr, rightArr) {
    if (isEmpty(leftArr)) {
        return [];
    }
    if (isEmpty(rightArr)) {
        return leftArr.slice(); // clone
    }
    var difference = leftArr.filter(function(x) {
        return rightArr.indexOf(x) == -1;
    });
    return difference;
};
// returns a random integer between 0 and max (exclusive)
var getRandomInt = function(max) {
    return Math.floor(Math.random() * Math.floor(max));
};
// shuffles array in place
var shuffleArrayInPlace = function(array) {
    for(var i = array.length - 1; i > 0; i--){
        var j = getRandomInt(i + 1);
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
};
/**
 * returns the nested object according to the key
 * i.e. obj = { outer: {inner: 3}}, key = "outer.inner" => return 3, key="other.inner" => return undefined
 * @param {Object} obj
 * @param {String} key
 */ var getNestedObject = function getNestedObject(obj, key) {
    return key.split(".").reduce(function(nested, currentKey) {
        return typeof nested == "undefined" || nested === null ? nested : nested[currentKey];
    }, obj);
};
/**
 * return true if the given object is empty (empty string / empty array / empty object / null / undefined)
 * @param {*} data
 */ var isEmpty = function(data) {
    if (typeof data == "number" || typeof data == "boolean") {
        return false;
    }
    if (typeof data == "undefined" || data === null) {
        return true;
    }
    if (typeof data.length != "undefined") {
        return data.length == 0;
    }
    for(var i in data){
        if (data.hasOwnProperty(i)) {
            return false;
        }
    }
    return true;
};
var UUID_LENGTH = 36;
var isUUID = function(str) {
    var regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return !!str.match(regex);
};
var sleep = function(milliseconds) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, milliseconds);
    });
};
var isFunction = function(value) {
    return typeof value === "function";
};
var mapValuesAsync = function(obj, asyncFn) {
    var keys = Object.keys(obj);
    var promises = keys.map(function(k) {
        return asyncFn(obj[k]).then(function(newValue) {
            return {
                key: k,
                value: newValue
            };
        });
    });
    return Promise.all(promises).then(function(values) {
        var newObj = {};
        values.forEach(function(v) {
            newObj[v.key] = v.value;
        });
        return newObj;
    });
};
var newUniqueArray = function(array) {
    return _toConsumableArray(new Set(array));
};
module.exports = {
    getArraysDifference: getArraysDifference,
    getRandomInt: getRandomInt,
    isEmpty: isEmpty,
    getNestedObject: getNestedObject,
    isUUID: isUUID,
    UUID_LENGTH: UUID_LENGTH,
    sleep: sleep,
    isFunction: isFunction,
    mapValuesAsync: mapValuesAsync,
    newUniqueArray: newUniqueArray,
    shuffleArrayInPlace: shuffleArrayInPlace
};


/***/ }),

/***/ 61012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ getHoverColor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var _color_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(273);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);
// https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)
// Version 4.1



var pSBC = function(p, c0, c1, l) {
    var r, g, b, P, f, t, h, m = Math.round, a = typeof c1 == "string";
    if (typeof p != "number" || p < -1 || p > 1 || typeof c0 != "string" || c0[0] != "r" && c0[0] != "#" || c1 && !a) return null;
    h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = pSBC.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? pSBC.pSBCr(c1) : P ? {
        r: 0,
        g: 0,
        b: 0,
        a: -1
    } : {
        r: 255,
        g: 255,
        b: 255,
        a: -1
    }, p = P ? p * -1 : p, P = 1 - p;
    if (!f || !t) return null;
    if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
    else r = m(Math.pow(P * Math.pow(f.r, 2) + p * Math.pow(t.r, 2), 0.5)), g = m(Math.pow(P * Math.pow(f.g, 2) + p * Math.pow(t.g, 2), 0.5)), b = m(Math.pow(P * Math.pow(f.b, 2) + p * Math.pow(t.b, 2), 0.5));
    a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
    if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
    else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
};
pSBC.pSBCr = function(d) {
    var i = parseInt;
    var n = d.length, x = {};
    if (n > 9) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(d = d.split(","), 4), r = ref[0], g = ref[1], b = ref[2], a = ref[3];
        n = d.length;
        if (n < 3 || n > 4) return null;
        x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1;
    } else {
        if (n == 8 || n == 6 || n < 4) return null;
        if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
        d = i(d.slice(1), 16);
        if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = Math.round((d & 255) / 0.255) / 1000;
        else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1;
    }
    return x;
};
var getHoverColor = function(colorValue) {
    var amount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -0.3;
    // TODO: add support for hover effect on gradients
    if (colorValue === _colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[_color_consts__WEBPACK_IMPORTED_MODULE_2__.GRADIANT_WORKOS_IRIS_COLOR_NAME]) {
        return _colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[_color_consts__WEBPACK_IMPORTED_MODULE_2__.GRADIANT_WORKOS_IRIS_HOVER_COLOR_NAME];
    }
    return pSBC(amount, colorValue);
};


/***/ }),

/***/ 34955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ isAndroid; },
/* harmony export */   "f5": function() { return /* binding */ appendUrlSchemeIfNeeded; },
/* harmony export */   "pN": function() { return /* binding */ isMeta; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; }
/* harmony export */ });
/* unused harmony exports isFacebook, isInstagram */
/* harmony import */ var services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76127);
/* harmony import */ var services_user_agent_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__);

var isAndroid = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isAndroidViewer)(userAgent);
};
var isMobile = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isMobileOrTabletViewer)(userAgent);
};
var isFacebook = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isFacebookViewer)(userAgent);
};
var isInstagram = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isInstagramViewer)(userAgent);
};
var isMeta = function(userAgentParam) {
    return isFacebook(userAgentParam) || isInstagram(userAgentParam);
};
var appendUrlSchemeIfNeeded = function(url) {
    var urlScheme = "";
    var urlSuffix = "";
    // https://stackoverflow.com/questions/64934340/google-sign-in-not-working-in-facebook-in-app-browser
    // force open in external browser
    if (isMeta() && isAndroid()) {
        urlScheme = "intent:https:";
        urlSuffix = "#Intent;end";
    }
    return "".concat(urlScheme).concat(url).concat(urlSuffix);
};


/***/ }),

/***/ 13688:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 90178:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 39590:
/***/ (function() {

/* (ignored) */

/***/ })

}]);